const _A = "Attachment";
const _AA = "ArchiveArn";
const _AAp = "ApplicationArn";
const _ACEA = "AdditionalContactEmailAddress";
const _ACEAd = "AdditionalContactEmailAddresses";
const _AD = "AccountDetails";
const _ADt = "AttributesData";
const _AE = "AdminEmail";
const _AEE = "AlreadyExistsException";
const _AL = "AttachmentList";
const _AO = "ArchivingOptions";
const _AS = "AccountStatus";
const _ASD = "ActiveSubscribedDomains";
const _ASE = "AccountSuspendedException";
const _ASMS = "AwsSesManagedStatus";
const _AT = "AssociatedTimestamp";
const _AWE = "AutoWarmupEnabled";
const _Ag = "Aggregation";
const _At = "Attachments";
const _Att = "Attributes";
const _B = "Body";
const _BA = "BccAddresses";
const _BE = "BlacklistEntry";
const _BEC = "BulkEmailContent";
const _BEE = "BulkEmailEntry";
const _BEEL = "BulkEmailEntryList";
const _BEER = "BulkEmailEntryResult";
const _BEERL = "BulkEmailEntryResultList";
const _BEERu = "BulkEmailEntryResults";
const _BEEu = "BulkEmailEntries";
const _BEl = "BlacklistEntries";
const _BGMD = "BatchGetMetricData";
const _BGMDQ = "BatchGetMetricDataQuery";
const _BGMDQa = "BatchGetMetricDataQueries";
const _BGMDR = "BatchGetMetricDataRequest";
const _BGMDRa = "BatchGetMetricDataResponse";
const _BIN = "BlacklistItemNames";
const _BOMF = "BehaviorOnMxFailure";
const _BR = "BlacklistReport";
const _BRE = "BadRequestException";
const _BST = "BounceSubType";
const _BT = "BounceType";
const _Bo = "Bounce";
const _C = "Complaint";
const _CA = "CcAddresses";
const _CC = "CreateContact";
const _CCL = "CreateContactList";
const _CCLR = "CreateContactListRequest";
const _CCLRr = "CreateContactListResponse";
const _CCR = "CreateContactRequest";
const _CCRr = "CreateContactResponse";
const _CCS = "CreateConfigurationSet";
const _CCSED = "CreateConfigurationSetEventDestination";
const _CCSEDR = "CreateConfigurationSetEventDestinationRequest";
const _CCSEDRr = "CreateConfigurationSetEventDestinationResponse";
const _CCSR = "CreateConfigurationSetRequest";
const _CCSRr = "CreateConfigurationSetResponse";
const _CCVET = "CreateCustomVerificationEmailTemplate";
const _CCVETR = "CreateCustomVerificationEmailTemplateRequest";
const _CCVETRr = "CreateCustomVerificationEmailTemplateResponse";
const _CD = "ContentDisposition";
const _CDIP = "CreateDedicatedIpPool";
const _CDIPR = "CreateDedicatedIpPoolRequest";
const _CDIPRr = "CreateDedicatedIpPoolResponse";
const _CDTR = "CreateDeliverabilityTestReport";
const _CDTRR = "CreateDeliverabilityTestReportRequest";
const _CDTRRr = "CreateDeliverabilityTestReportResponse";
const _CDo = "ContentDescription";
const _CDr = "CreateDate";
const _CE = "ConflictException";
const _CEI = "CreateEmailIdentity";
const _CEIP = "CreateEmailIdentityPolicy";
const _CEIPR = "CreateEmailIdentityPolicyRequest";
const _CEIPRr = "CreateEmailIdentityPolicyResponse";
const _CEIR = "CreateEmailIdentityRequest";
const _CEIRr = "CreateEmailIdentityResponse";
const _CEJ = "CancelExportJob";
const _CEJR = "CancelExportJobRequest";
const _CEJRa = "CancelExportJobResponse";
const _CEJRr = "CreateExportJobRequest";
const _CEJRre = "CreateExportJobResponse";
const _CEJr = "CreateExportJob";
const _CET = "CreateEmailTemplate";
const _CETR = "CreateEmailTemplateRequest";
const _CETRr = "CreateEmailTemplateResponse";
const _CFT = "ComplaintFeedbackType";
const _CI = "ContentId";
const _CIJ = "CreateImportJob";
const _CIJR = "CreateImportJobRequest";
const _CIJRr = "CreateImportJobResponse";
const _CIa = "CampaignId";
const _CIas = "CaseId";
const _CL = "ContactLanguage";
const _CLD = "ContactListDestination";
const _CLIA = "ContactListImportAction";
const _CLN = "ContactListName";
const _CLo = "ContactList";
const _CLon = "ContactLists";
const _CME = "ConcurrentModificationException";
const _CMRE = "CreateMultiRegionEndpoint";
const _CMRER = "CreateMultiRegionEndpointRequest";
const _CMRERr = "CreateMultiRegionEndpointResponse";
const _CMS = "CustomerManagedStatus";
const _CP = "CurrentPlan";
const _CRD = "CustomRedirectDomain";
const _CS = "ConfigurationSets";
const _CSKL = "CurrentSigningKeyLength";
const _CSN = "ConfigurationSetName";
const _CST = "ComplaintSubType";
const _CT = "ContentType";
const _CTE = "ContentTransferEncoding";
const _CTEo = "ConditionThresholdEnabled";
const _CTR = "CreateTenantRequest";
const _CTRA = "CreateTenantResourceAssociation";
const _CTRAR = "CreateTenantResourceAssociationRequest";
const _CTRARr = "CreateTenantResourceAssociationResponse";
const _CTRr = "CreateTenantResponse";
const _CTo = "CompletedTimestamp";
const _CTon = "ConditionThreshold";
const _CTr = "CreatedTimestamp";
const _CTre = "CreateTenant";
const _CV = "ConfidenceVerdict";
const _CVET = "CustomVerificationEmailTemplates";
const _CVETL = "CustomVerificationEmailTemplatesList";
const _CVETM = "CustomVerificationEmailTemplateMetadata";
const _CVT = "ConfidenceVerdictThreshold";
const _CWD = "CloudWatchDestination";
const _CWDC = "CloudWatchDimensionConfiguration";
const _CWDCl = "CloudWatchDimensionConfigurations";
const _Ca = "Cause";
const _Ch = "Charset";
const _Co = "Contact";
const _Cod = "Code";
const _Con = "Content";
const _Cont = "Contacts";
const _D = "Dimensions";
const _DA = "DkimAttributes";
const _DAa = "DashboardAttributes";
const _DC = "DiagnosticCode";
const _DCL = "DeleteContactList";
const _DCLR = "DeleteContactListRequest";
const _DCLRe = "DeleteContactListResponse";
const _DCR = "DeleteContactRequest";
const _DCRe = "DeleteContactResponse";
const _DCS = "DeleteConfigurationSet";
const _DCSED = "DeleteConfigurationSetEventDestination";
const _DCSEDR = "DeleteConfigurationSetEventDestinationRequest";
const _DCSEDRe = "DeleteConfigurationSetEventDestinationResponse";
const _DCSR = "DeleteConfigurationSetRequest";
const _DCSRe = "DeleteConfigurationSetResponse";
const _DCVET = "DeleteCustomVerificationEmailTemplate";
const _DCVETR = "DeleteCustomVerificationEmailTemplateRequest";
const _DCVETRe = "DeleteCustomVerificationEmailTemplateResponse";
const _DCe = "DefaultContent";
const _DCel = "DeleteContact";
const _DCi = "DimensionConfigurations";
const _DDC = "DomainDeliverabilityCampaign";
const _DDCL = "DomainDeliverabilityCampaignList";
const _DDCo = "DomainDeliverabilityCampaigns";
const _DDIP = "DeleteDedicatedIpPool";
const _DDIPR = "DeleteDedicatedIpPoolRequest";
const _DDIPRe = "DeleteDedicatedIpPoolResponse";
const _DDTO = "DomainDeliverabilityTrackingOption";
const _DDTOo = "DomainDeliverabilityTrackingOptions";
const _DDV = "DefaultDimensionValue";
const _DE = "DashboardEnabled";
const _DEI = "DeleteEmailIdentity";
const _DEIP = "DeleteEmailIdentityPolicy";
const _DEIPR = "DeleteEmailIdentityPolicyRequest";
const _DEIPRe = "DeleteEmailIdentityPolicyResponse";
const _DEIR = "DeleteEmailIdentityRequest";
const _DEIRe = "DeleteEmailIdentityResponse";
const _DET = "DefaultEmailTags";
const _DETR = "DeleteEmailTemplateRequest";
const _DETRe = "DeleteEmailTemplateResponse";
const _DETe = "DeleteEmailTemplate";
const _DF = "DataFormat";
const _DI = "DedicatedIp";
const _DIAWE = "DedicatedIpAutoWarmupEnabled";
const _DIL = "DedicatedIpList";
const _DIP = "DomainIspPlacements";
const _DIPe = "DedicatedIpPool";
const _DIPed = "DedicatedIpPools";
const _DIPo = "DomainIspPlacement";
const _DIe = "DedicatedIps";
const _DMRE = "DeleteMultiRegionEndpoint";
const _DMRER = "DeleteMultiRegionEndpointRequest";
const _DMRERe = "DeleteMultiRegionEndpointResponse";
const _DN = "DimensionName";
const _DNi = "DisplayName";
const _DO = "DeliveryOptions";
const _DOa = "DashboardOptions";
const _DP = "DkimPercentage";
const _DPN = "DestinationPoolName";
const _DR = "DeleteRate";
const _DS = "DkimStatus";
const _DSA = "DkimSigningAttributes";
const _DSAO = "DomainSigningAttributesOrigin";
const _DSAe = "DeliveryStreamArn";
const _DSD = "DeleteSuppressedDestination";
const _DSDR = "DeleteSuppressedDestinationRequest";
const _DSDRe = "DeleteSuppressedDestinationResponse";
const _DSPK = "DomainSigningPrivateKey";
const _DSS = "DomainSigningSelector";
const _DSSe = "DefaultSubscriptionStatus";
const _DT = "DkimTokens";
const _DTR = "DeleteTenantRequest";
const _DTRA = "DeleteTenantResourceAssociation";
const _DTRAR = "DeleteTenantResourceAssociationRequest";
const _DTRARe = "DeleteTenantResourceAssociationResponse";
const _DTRe = "DeleteTenantResponse";
const _DTRel = "DeliverabilityTestReport";
const _DTReli = "DeliverabilityTestReports";
const _DTS = "DeliverabilityTestStatus";
const _DTe = "DeleteTenant";
const _DV = "DailyVolume";
const _DVS = "DimensionValueSource";
const _DVa = "DailyVolumes";
const _Da = "Data";
const _De = "Description";
const _Des = "Destination";
const _Det = "Details";
const _Do = "Domain";
const _E = "Errors";
const _EA = "EmailAddress";
const _EAFL = "EmailAddressFilterList";
const _EAIME = "EmailAddressInsightsMailboxEvaluations";
const _EAIV = "EmailAddressInsightsVerdict";
const _EBA = "EventBusArn";
const _EBD = "EventBridgeDestination";
const _EC = "EmailContent";
const _ED = "EndDate";
const _EDD = "EventDestinationDefinition";
const _EDN = "EventDestinationName";
const _EDS = "ExportDataSource";
const _EDv = "EventDestination";
const _EDve = "EventDetails";
const _EDven = "EventDestinations";
const _EDx = "ExportDestination";
const _EDxp = "ExportDimensions";
const _EFE = "EmailForwardingEnabled";
const _EI = "EmailIdentity";
const _EIL = "EmailInsightsList";
const _EIm = "EmailInsights";
const _EIma = "EmailIdentities";
const _EIn = "EndpointId";
const _EJ = "ExportJobs";
const _EJS = "ExportJobSummary";
const _EJSL = "ExportJobSummaryList";
const _EM = "EngagementMetrics";
const _EMr = "ErrorMessage";
const _EMx = "ExportMetric";
const _EMxp = "ExportMetrics";
const _EN = "EndpointName";
const _ERC = "ExportedRecordsCount";
const _ES = "EmailSubject";
const _ESFL = "EmailSubjectFilterList";
const _EST = "ExportSourceType";
const _ESn = "EnforcementStatus";
const _ESx = "ExportStatistics";
const _ET = "EmailTags";
const _ETC = "EmailTemplateContent";
const _ETM = "EmailTemplateMetadata";
const _ETML = "EmailTemplateMetadataList";
const _ETr = "ErrorType";
const _En = "Enabled";
const _Er = "Error";
const _Es = "Esps";
const _Ev = "Events";
const _Eva = "Evaluations";
const _Ex = "Exclude";
const _F = "Filter";
const _FA = "FromAddress";
const _FEA = "FromEmailAddress";
const _FEAIA = "FromEmailAddressIdentityArn";
const _FFEA = "FeedbackForwardingEmailAddress";
const _FFEAIA = "FeedbackForwardingEmailAddressIdentityArn";
const _FFS = "FeedbackForwardingStatus";
const _FI = "FailureInfo";
const _FIe = "FeedbackId";
const _FN = "FileName";
const _FRC = "FailedRecordsCount";
const _FRSU = "FailedRecordsS3Url";
const _FRURL = "FailureRedirectionURL";
const _FS = "FilteredStatus";
const _FSDT = "FirstSeenDateTime";
const _G = "Global";
const _GA = "GuardianAttributes";
const _GAR = "GetAccountRequest";
const _GARe = "GetAccountResponse";
const _GAe = "GetAccount";
const _GBR = "GetBlacklistReports";
const _GBRR = "GetBlacklistReportsRequest";
const _GBRRe = "GetBlacklistReportsResponse";
const _GC = "GetContact";
const _GCL = "GetContactList";
const _GCLR = "GetContactListRequest";
const _GCLRe = "GetContactListResponse";
const _GCR = "GetContactRequest";
const _GCRe = "GetContactResponse";
const _GCS = "GetConfigurationSet";
const _GCSED = "GetConfigurationSetEventDestinations";
const _GCSEDR = "GetConfigurationSetEventDestinationsRequest";
const _GCSEDRe = "GetConfigurationSetEventDestinationsResponse";
const _GCSR = "GetConfigurationSetRequest";
const _GCSRe = "GetConfigurationSetResponse";
const _GCVET = "GetCustomVerificationEmailTemplate";
const _GCVETR = "GetCustomVerificationEmailTemplateRequest";
const _GCVETRe = "GetCustomVerificationEmailTemplateResponse";
const _GDDC = "GetDomainDeliverabilityCampaign";
const _GDDCR = "GetDomainDeliverabilityCampaignRequest";
const _GDDCRe = "GetDomainDeliverabilityCampaignResponse";
const _GDDO = "GetDeliverabilityDashboardOptions";
const _GDDOR = "GetDeliverabilityDashboardOptionsRequest";
const _GDDORe = "GetDeliverabilityDashboardOptionsResponse";
const _GDI = "GetDedicatedIp";
const _GDIP = "GetDedicatedIpPool";
const _GDIPR = "GetDedicatedIpPoolRequest";
const _GDIPRe = "GetDedicatedIpPoolResponse";
const _GDIR = "GetDedicatedIpRequest";
const _GDIRe = "GetDedicatedIpResponse";
const _GDIRet = "GetDedicatedIpsRequest";
const _GDIRete = "GetDedicatedIpsResponse";
const _GDIe = "GetDedicatedIps";
const _GDSR = "GetDomainStatisticsReport";
const _GDSRR = "GetDomainStatisticsReportRequest";
const _GDSRRe = "GetDomainStatisticsReportResponse";
const _GDTR = "GetDeliverabilityTestReport";
const _GDTRR = "GetDeliverabilityTestReportRequest";
const _GDTRRe = "GetDeliverabilityTestReportResponse";
const _GEAI = "GetEmailAddressInsights";
const _GEAIR = "GetEmailAddressInsightsRequest";
const _GEAIRe = "GetEmailAddressInsightsResponse";
const _GEI = "GetEmailIdentity";
const _GEIP = "GetEmailIdentityPolicies";
const _GEIPR = "GetEmailIdentityPoliciesRequest";
const _GEIPRe = "GetEmailIdentityPoliciesResponse";
const _GEIR = "GetEmailIdentityRequest";
const _GEIRe = "GetEmailIdentityResponse";
const _GEJ = "GetExportJob";
const _GEJR = "GetExportJobRequest";
const _GEJRe = "GetExportJobResponse";
const _GET = "GetEmailTemplate";
const _GETR = "GetEmailTemplateRequest";
const _GETRe = "GetEmailTemplateResponse";
const _GIJ = "GetImportJob";
const _GIJR = "GetImportJobRequest";
const _GIJRe = "GetImportJobResponse";
const _GMI = "GetMessageInsights";
const _GMIR = "GetMessageInsightsRequest";
const _GMIRe = "GetMessageInsightsResponse";
const _GMRE = "GetMultiRegionEndpoint";
const _GMRER = "GetMultiRegionEndpointRequest";
const _GMRERe = "GetMultiRegionEndpointResponse";
const _GO = "GuardianOptions";
const _GRE = "GetReputationEntity";
const _GRER = "GetReputationEntityRequest";
const _GRERe = "GetReputationEntityResponse";
const _GSD = "GetSuppressedDestination";
const _GSDR = "GetSuppressedDestinationRequest";
const _GSDRe = "GetSuppressedDestinationResponse";
const _GT = "GetTenant";
const _GTR = "GetTenantRequest";
const _GTRe = "GetTenantResponse";
const _H = "Html";
const _HP = "HttpsPolicy";
const _HVDR = "HasValidDnsRecords";
const _HVS = "HasValidSyntax";
const _He = "Headers";
const _I = "Id";
const _IC = "InboxCount";
const _ID = "ImportDestination";
const _IDS = "ImportDataSource";
const _IDT = "ImportDestinationType";
const _IDs = "IsDisposable";
const _IE = "InsightsEvent";
const _IEA = "InsightsEmailAddress";
const _IEn = "InsightsEvents";
const _II = "IdentityInfo";
const _IIL = "IdentityInfoList";
const _IJ = "ImportJobs";
const _IJS = "ImportJobSummary";
const _IJSL = "ImportJobSummaryList";
const _IN = "IspName";
const _INTE = "InvalidNextTokenException";
const _INd = "IdentityName";
const _IP = "InboxPercentage";
const _IPTO = "InboxPlacementTrackingOption";
const _IPs = "IspPlacements";
const _IPsp = "IspPlacement";
const _IRA = "IsRoleAddress";
const _IRAa = "IamRoleArn";
const _IRC = "InboxRawCount";
const _IRI = "IsRandomInput";
const _ISEE = "InternalServiceErrorException";
const _IT = "IdentityType";
const _IU = "ImageUrl";
const _IV = "IsValid";
const _Im = "Impact";
const _In = "Insights";
const _Inc = "Include";
const _Ip = "Ip";
const _Is = "Isp";
const _JI = "JobId";
const _JS = "JobStatus";
const _K = "Key";
const _KFD = "KinesisFirehoseDestination";
const _LC = "ListContacts";
const _LCF = "ListContactsFilter";
const _LCL = "ListContactLists";
const _LCLR = "ListContactListsRequest";
const _LCLRi = "ListContactListsResponse";
const _LCR = "ListContactsRequest";
const _LCRi = "ListContactsResponse";
const _LCS = "ListConfigurationSets";
const _LCSR = "ListConfigurationSetsRequest";
const _LCSRi = "ListConfigurationSetsResponse";
const _LCT = "LastCheckedTimestamp";
const _LCVET = "ListCustomVerificationEmailTemplates";
const _LCVETR = "ListCustomVerificationEmailTemplatesRequest";
const _LCVETRi = "ListCustomVerificationEmailTemplatesResponse";
const _LDDC = "ListDomainDeliverabilityCampaigns";
const _LDDCR = "ListDomainDeliverabilityCampaignsRequest";
const _LDDCRi = "ListDomainDeliverabilityCampaignsResponse";
const _LDE = "LastDeliveryEvent";
const _LDIP = "ListDedicatedIpPools";
const _LDIPR = "ListDedicatedIpPoolsRequest";
const _LDIPRi = "ListDedicatedIpPoolsResponse";
const _LDTR = "ListDeliverabilityTestReports";
const _LDTRR = "ListDeliverabilityTestReportsRequest";
const _LDTRRi = "ListDeliverabilityTestReportsResponse";
const _LEE = "LimitExceededException";
const _LEEa = "LastEngagementEvent";
const _LEI = "ListEmailIdentities";
const _LEIR = "ListEmailIdentitiesRequest";
const _LEIRi = "ListEmailIdentitiesResponse";
const _LEJ = "ListExportJobs";
const _LEJR = "ListExportJobsRequest";
const _LEJRi = "ListExportJobsResponse";
const _LET = "ListEmailTemplates";
const _LETR = "ListEmailTemplatesRequest";
const _LETRi = "ListEmailTemplatesResponse";
const _LFS = "LastFreshStart";
const _LIJ = "ListImportJobs";
const _LIJR = "ListImportJobsRequest";
const _LIJRi = "ListImportJobsResponse";
const _LKGT = "LastKeyGenerationTimestamp";
const _LMO = "ListManagementOptions";
const _LMRE = "ListMultiRegionEndpoints";
const _LMRER = "ListMultiRegionEndpointsRequest";
const _LMRERi = "ListMultiRegionEndpointsResponse";
const _LOC = "ListOfContacts";
const _LOCL = "ListOfContactLists";
const _LR = "ListRecommendations";
const _LRE = "ListReputationEntities";
const _LRER = "ListReputationEntitiesRequest";
const _LRERi = "ListReputationEntitiesResponse";
const _LRR = "ListRecommendationsRequest";
const _LRRi = "ListRecommendationsResponse";
const _LRT = "ListResourceTenants";
const _LRTR = "ListResourceTenantsRequest";
const _LRTRi = "ListResourceTenantsResponse";
const _LSD = "ListSuppressedDestinations";
const _LSDR = "ListSuppressedDestinationsRequest";
const _LSDRi = "ListSuppressedDestinationsResponse";
const _LSDT = "LastSeenDateTime";
const _LST = "LastSuccessTimestamp";
const _LT = "ListingTime";
const _LTFR = "ListTagsForResource";
const _LTFRR = "ListTagsForResourceRequest";
const _LTFRRi = "ListTagsForResourceResponse";
const _LTR = "ListTenantsRequest";
const _LTRR = "ListTenantResourcesRequest";
const _LTRRi = "ListTenantResourcesResponse";
const _LTRi = "ListTenantsResponse";
const _LTRis = "ListTenantResources";
const _LTi = "ListTenants";
const _LUT = "LastUpdatedTimestamp";
const _LUTa = "LastUpdateTime";
const _M = "Metric";
const _MDE = "MetricDataError";
const _MDEL = "MetricDataErrorList";
const _MDR = "MetricDataResult";
const _MDRL = "MetricDataResultList";
const _MDS = "MaxDeliverySeconds";
const _MDSe = "MetricsDataSource";
const _ME = "MailboxExists";
const _MET = "MatchingEventTypes";
const _MFA = "MailFromAttributes";
const _MFD = "MailFromDomain";
const _MFDNVE = "MailFromDomainNotVerifiedException";
const _MFDS = "MailFromDomainStatus";
const _MH = "MessageHeader";
const _MHL = "MessageHeaderList";
const _MHS = "Max24HourSend";
const _MI = "MessageId";
const _MIDS = "MessageInsightsDataSource";
const _MIF = "MessageInsightsFilters";
const _MP = "MissingPercentage";
const _MR = "MessageRejected";
const _MRE = "MultiRegionEndpoints";
const _MREu = "MultiRegionEndpoint";
const _MRa = "MaxResults";
const _MSR = "MaxSendRate";
const _MT = "MailType";
const _MTL = "MessageTagList";
const _MTe = "MessageTag";
const _MV = "MailboxValidation";
const _Me = "Message";
const _Met = "Metrics";
const _N = "Namespace";
const _NFE = "NotFoundException";
const _NP = "NextPlan";
const _NSKL = "NextSigningKeyLength";
const _NT = "NextToken";
const _Na = "Name";
const _OCT = "OverallConfidenceThreshold";
const _OP = "OverallPlacement";
const _OSD = "OptimizedSharedDelivery";
const _OV = "OverallVolume";
const _P = "Policy";
const _PA = "PricingAttributes";
const _PAD = "PutAccountDetails";
const _PADIWA = "PutAccountDedicatedIpWarmupAttributes";
const _PADIWAR = "PutAccountDedicatedIpWarmupAttributesRequest";
const _PADIWARu = "PutAccountDedicatedIpWarmupAttributesResponse";
const _PADR = "PutAccountDetailsRequest";
const _PADRu = "PutAccountDetailsResponse";
const _PAE = "ProductionAccessEnabled";
const _PAPA = "PutAccountPricingAttributes";
const _PAPAR = "PutAccountPricingAttributesRequest";
const _PAPARu = "PutAccountPricingAttributesResponse";
const _PASA = "PutAccountSendingAttributes";
const _PASAR = "PutAccountSendingAttributesRequest";
const _PASARu = "PutAccountSendingAttributesResponse";
const _PASARut = "PutAccountSuppressionAttributesRequest";
const _PASARutc = "PutAccountSuppressionAttributesResponse";
const _PASAu = "PutAccountSuppressionAttributes";
const _PAVA = "PutAccountVdmAttributes";
const _PAVAR = "PutAccountVdmAttributesRequest";
const _PAVARu = "PutAccountVdmAttributesResponse";
const _PCSAO = "PutConfigurationSetArchivingOptions";
const _PCSAOR = "PutConfigurationSetArchivingOptionsRequest";
const _PCSAORu = "PutConfigurationSetArchivingOptionsResponse";
const _PCSDO = "PutConfigurationSetDeliveryOptions";
const _PCSDOR = "PutConfigurationSetDeliveryOptionsRequest";
const _PCSDORu = "PutConfigurationSetDeliveryOptionsResponse";
const _PCSRO = "PutConfigurationSetReputationOptions";
const _PCSROR = "PutConfigurationSetReputationOptionsRequest";
const _PCSRORu = "PutConfigurationSetReputationOptionsResponse";
const _PCSSO = "PutConfigurationSetSendingOptions";
const _PCSSOR = "PutConfigurationSetSendingOptionsRequest";
const _PCSSORu = "PutConfigurationSetSendingOptionsResponse";
const _PCSSORut = "PutConfigurationSetSuppressionOptionsRequest";
const _PCSSORuto = "PutConfigurationSetSuppressionOptionsResponse";
const _PCSSOu = "PutConfigurationSetSuppressionOptions";
const _PCSTO = "PutConfigurationSetTrackingOptions";
const _PCSTOR = "PutConfigurationSetTrackingOptionsRequest";
const _PCSTORu = "PutConfigurationSetTrackingOptionsResponse";
const _PCSVO = "PutConfigurationSetVdmOptions";
const _PCSVOR = "PutConfigurationSetVdmOptionsRequest";
const _PCSVORu = "PutConfigurationSetVdmOptionsResponse";
const _PD = "PinpointDestination";
const _PDDO = "PutDeliverabilityDashboardOption";
const _PDDOR = "PutDeliverabilityDashboardOptionRequest";
const _PDDORu = "PutDeliverabilityDashboardOptionResponse";
const _PDIIP = "PutDedicatedIpInPool";
const _PDIIPR = "PutDedicatedIpInPoolRequest";
const _PDIIPRu = "PutDedicatedIpInPoolResponse";
const _PDIPSA = "PutDedicatedIpPoolScalingAttributes";
const _PDIPSAR = "PutDedicatedIpPoolScalingAttributesRequest";
const _PDIPSARu = "PutDedicatedIpPoolScalingAttributesResponse";
const _PDIWA = "PutDedicatedIpWarmupAttributes";
const _PDIWAR = "PutDedicatedIpWarmupAttributesRequest";
const _PDIWARu = "PutDedicatedIpWarmupAttributesResponse";
const _PEICSA = "PutEmailIdentityConfigurationSetAttributes";
const _PEICSAR = "PutEmailIdentityConfigurationSetAttributesRequest";
const _PEICSARu = "PutEmailIdentityConfigurationSetAttributesResponse";
const _PEIDA = "PutEmailIdentityDkimAttributes";
const _PEIDAR = "PutEmailIdentityDkimAttributesRequest";
const _PEIDARu = "PutEmailIdentityDkimAttributesResponse";
const _PEIDSA = "PutEmailIdentityDkimSigningAttributes";
const _PEIDSAR = "PutEmailIdentityDkimSigningAttributesRequest";
const _PEIDSARu = "PutEmailIdentityDkimSigningAttributesResponse";
const _PEIFA = "PutEmailIdentityFeedbackAttributes";
const _PEIFAR = "PutEmailIdentityFeedbackAttributesRequest";
const _PEIFARu = "PutEmailIdentityFeedbackAttributesResponse";
const _PEIMFA = "PutEmailIdentityMailFromAttributes";
const _PEIMFAR = "PutEmailIdentityMailFromAttributesRequest";
const _PEIMFARu = "PutEmailIdentityMailFromAttributesResponse";
const _PESD = "PendingExpirationSubscribedDomains";
const _PI = "ProjectedInbox";
const _PK = "PrivateKey";
const _PN = "PoolName";
const _PNS = "PrimaryNameServer";
const _PNo = "PolicyName";
const _PRC = "ProcessedRecordsCount";
const _PS = "PageSize";
const _PSD = "PutSuppressedDestination";
const _PSDR = "PutSuppressedDestinationRequest";
const _PSDRu = "PutSuppressedDestinationResponse";
const _PSl = "PlacementStatistics";
const _PSr = "ProjectedSpam";
const _PTSA = "PutTenantSuppressionAttributes";
const _PTSAR = "PutTenantSuppressionAttributesRequest";
const _PTSARu = "PutTenantSuppressionAttributesResponse";
const _PV = "ProjectedVolume";
const _Pl = "Plan";
const _Po = "Policies";
const _Q = "Queries";
const _R = "Results";
const _RA = "ResourceArn";
const _RC = "RawContent";
const _RD = "ReviewDetails";
const _RDR = "ReadDeleteRate";
const _RDo = "RoutesDetails";
const _RDou = "RouteDetails";
const _RE = "ReputationEntity";
const _REC = "ReplacementEmailContent";
const _REL = "ReputationEntitiesList";
const _REP = "ReputationEntityPolicy";
const _RER = "ReputationEntityReference";
const _RET = "ReputationEntityType";
const _REe = "ReputationEntities";
const _RH = "ReplacementHeaders";
const _RI = "ReportId";
const _RIe = "ReputationImpact";
const _RL = "RecommendationsList";
const _RM = "RawMessage";
const _RME = "ReputationMetricsEnabled";
const _RMP = "ReputationManagementPolicy";
const _RN = "RblName";
const _RNe = "ReportName";
const _RO = "ReputationOptions";
const _RR = "ReadRate";
const _RRP = "ReadRatePercent";
const _RT = "ReplacementTags";
const _RTA = "ReplyToAddresses";
const _RTD = "ReplacementTemplateData";
const _RTM = "ResourceTenantMetadata";
const _RTML = "ResourceTenantMetadataList";
const _RTe = "ResourceTenants";
const _RTen = "RenderedTemplate";
const _RTep = "ReplacementTemplate";
const _RTes = "ResourceType";
const _Ra = "Raw";
const _Re = "Recommendations";
const _Rea = "Reasons";
const _Reas = "Reason";
const _Rec = "Recommendation";
const _Reg = "Regions";
const _Regi = "Region";
const _Ro = "Routes";
const _Rou = "Route";
const _S = "Status";
const _SA = "SuppressionAttributes";
const _SAO = "SigningAttributesOrigin";
const _SAi = "SigningAttributes";
const _SBE = "SendBulkEmail";
const _SBER = "SendBulkEmailRequest";
const _SBERe = "SendBulkEmailResponse";
const _SC = "SpamCount";
const _SCT = "SuppressionConditionThreshold";
const _SCTu = "SuppressionConfidenceThreshold";
const _SCVE = "SendCustomVerificationEmail";
const _SCVER = "SendCustomVerificationEmailRequest";
const _SCVERe = "SendCustomVerificationEmailResponse";
const _SD = "StartDate";
const _SDA = "SuppressedDestinationAttributes";
const _SDS = "SuppressedDestinationSummaries";
const _SDSu = "SuppressedDestinationSummary";
const _SDn = "SnsDestination";
const _SDu = "SuppressedDestination";
const _SDub = "SubscribedDomain";
const _SDubs = "SubscribedDomains";
const _SE = "SigningEnabled";
const _SED = "SubscriptionExpiryDate";
const _SER = "SendEmailRequest";
const _SERe = "SendEmailResponse";
const _SEe = "SendingEnabled";
const _SEen = "SendEmail";
const _SHZ = "SigningHostedZone";
const _SI = "SendingIps";
const _SLD = "SuppressionListDestination";
const _SLH = "SentLast24Hours";
const _SLIA = "SuppressionListImportAction";
const _SM = "ScalingMode";
const _SN = "SerialNumber";
const _SO = "SendingOptions";
const _SOAR = "SOARecord";
const _SOu = "SuppressionOptions";
const _SP = "SpamPercentage";
const _SPE = "SendingPausedException";
const _SPN = "SendingPoolName";
const _SPp = "SpfPercentage";
const _SQ = "SendQuota";
const _SR = "SuppressedReasons";
const _SRC = "SpamRawCount";
const _SRURL = "SuccessRedirectionURL";
const _SRt = "StatusRecord";
const _SS = "SendingStatus";
const _SSA = "SendingStatusAggregate";
const _SSD = "SubscriptionStartDate";
const _SSu = "SuppressionScope";
const _SSub = "SubscriptionStatus";
const _SU = "S3Url";
const _SVA = "SuppressionValidationAttributes";
const _SVO = "SuppressionValidationOptions";
const _Si = "Simple";
const _St = "Statistics";
const _Su = "Subject";
const _T = "Text";
const _TA = "TenantArn";
const _TAe = "TemplateArn";
const _TAo = "ToAddresses";
const _TAop = "TopicArn";
const _TC = "TemplateContent";
const _TD = "TemplateData";
const _TDP = "TopicDefaultPreferences";
const _TF = "TopicFilter";
const _TI = "TenantId";
const _TIL = "TenantInfoList";
const _TIe = "TenantInfo";
const _TIr = "TrackedIsps";
const _TK = "TagKeys";
const _TL = "TagList";
const _TM = "TemplatesMetadata";
const _TMRE = "TooManyRequestsException";
const _TN = "TemplateName";
const _TNe = "TenantName";
const _TNo = "TopicName";
const _TO = "TrackingOptions";
const _TP = "TopicPreferences";
const _TPL = "TopicPreferenceList";
const _TPl = "TlsPolicy";
const _TPo = "TopicPreference";
const _TR = "TenantResources";
const _TRET = "TestRenderEmailTemplate";
const _TRETR = "TestRenderEmailTemplateRequest";
const _TRETRe = "TestRenderEmailTemplateResponse";
const _TRL = "TenantResourceList";
const _TRR = "TagResourceRequest";
const _TRRa = "TagResourceResponse";
const _TRa = "TagResource";
const _TRe = "TenantResource";
const _TS = "TemplateSubject";
const _TSA = "TenantSuppressionAttributes";
const _Ta = "Tags";
const _Tag = "Tag";
const _Te = "Template";
const _Ten = "Tenant";
const _Tena = "Tenants";
const _Ti = "Timestamp";
const _Tim = "Timestamps";
const _To = "Topics";
const _Tok = "Tokens";
const _Top = "Topic";
const _Ty = "Type";
const _UA = "UnsubscribeAll";
const _UC = "UpdateContact";
const _UCD = "UseCaseDescription";
const _UCL = "UpdateContactList";
const _UCLR = "UpdateContactListRequest";
const _UCLRp = "UpdateContactListResponse";
const _UCR = "UpdateContactRequest";
const _UCRp = "UpdateContactResponse";
const _UCSED = "UpdateConfigurationSetEventDestination";
const _UCSEDR = "UpdateConfigurationSetEventDestinationRequest";
const _UCSEDRp = "UpdateConfigurationSetEventDestinationResponse";
const _UCVET = "UpdateCustomVerificationEmailTemplate";
const _UCVETR = "UpdateCustomVerificationEmailTemplateRequest";
const _UCVETRp = "UpdateCustomVerificationEmailTemplateResponse";
const _UDIPU = "UseDefaultIfPreferenceUnavailable";
const _UEIP = "UpdateEmailIdentityPolicy";
const _UEIPR = "UpdateEmailIdentityPolicyRequest";
const _UEIPRp = "UpdateEmailIdentityPolicyResponse";
const _UET = "UpdateEmailTemplate";
const _UETR = "UpdateEmailTemplateRequest";
const _UETRp = "UpdateEmailTemplateResponse";
const _UR = "UntagResource";
const _URECMS = "UpdateReputationEntityCustomerManagedStatus";
const _URECMSR = "UpdateReputationEntityCustomerManagedStatusRequest";
const _URECMSRp = "UpdateReputationEntityCustomerManagedStatusResponse";
const _UREP = "UpdateReputationEntityPolicy";
const _UREPR = "UpdateReputationEntityPolicyRequest";
const _UREPRp = "UpdateReputationEntityPolicyResponse";
const _URR = "UntagResourceRequest";
const _URRn = "UntagResourceResponse";
const _V = "Value";
const _VA = "VdmAttributes";
const _VAa = "ValidationAttributes";
const _VE = "VdmEnabled";
const _VFSS = "VerifiedForSendingStatus";
const _VI = "VerificationInfo";
const _VO = "VdmOptions";
const _VOa = "ValidationOptions";
const _VS = "VolumeStatistics";
const _VSe = "VerificationStatus";
const _Va = "Values";
const _WP = "WarmupPercentage";
const _WS = "WarmupStatus";
const _WURL = "WebsiteURL";
const _c = "client";
const _e = "error";
const _h = "http";
const _hE = "httpError";
const _hQ = "httpQuery";
const _m = "message";
const _s = "smithy.ts.sdk.synthetic.com.amazonaws.sesv2";
const _se = "server";
const n0 = "com.amazonaws.sesv2";
import { TypeRegistry } from "@smithy/core/schema";
import { AccountSuspendedException, AlreadyExistsException, BadRequestException, ConcurrentModificationException, ConflictException, InternalServiceErrorException, InvalidNextTokenException, LimitExceededException, MailFromDomainNotVerifiedException, MessageRejected, NotFoundException, SendingPausedException, TooManyRequestsException, } from "../models/errors";
import { SESv2ServiceException } from "../models/SESv2ServiceException";
const _s_registry = TypeRegistry.for(_s);
export var SESv2ServiceException$ = [-3, _s, "SESv2ServiceException", 0, [], []];
_s_registry.registerError(SESv2ServiceException$, SESv2ServiceException);
const n0_registry = TypeRegistry.for(n0);
export var AccountSuspendedException$ = [-3, n0, _ASE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(AccountSuspendedException$, AccountSuspendedException);
export var AlreadyExistsException$ = [-3, n0, _AEE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(AlreadyExistsException$, AlreadyExistsException);
export var BadRequestException$ = [-3, n0, _BRE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(BadRequestException$, BadRequestException);
export var ConcurrentModificationException$ = [-3, n0, _CME,
    { [_e]: _se, [_hE]: 500 },
    [_m],
    [0]
];
n0_registry.registerError(ConcurrentModificationException$, ConcurrentModificationException);
export var ConflictException$ = [-3, n0, _CE,
    { [_e]: _c, [_hE]: 409 },
    [_m],
    [0]
];
n0_registry.registerError(ConflictException$, ConflictException);
export var InternalServiceErrorException$ = [-3, n0, _ISEE,
    { [_e]: _se, [_hE]: 500 },
    [_m],
    [0]
];
n0_registry.registerError(InternalServiceErrorException$, InternalServiceErrorException);
export var InvalidNextTokenException$ = [-3, n0, _INTE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(InvalidNextTokenException$, InvalidNextTokenException);
export var LimitExceededException$ = [-3, n0, _LEE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(LimitExceededException$, LimitExceededException);
export var MailFromDomainNotVerifiedException$ = [-3, n0, _MFDNVE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(MailFromDomainNotVerifiedException$, MailFromDomainNotVerifiedException);
export var MessageRejected$ = [-3, n0, _MR,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(MessageRejected$, MessageRejected);
export var NotFoundException$ = [-3, n0, _NFE,
    { [_e]: _c, [_hE]: 404 },
    [_m],
    [0]
];
n0_registry.registerError(NotFoundException$, NotFoundException);
export var SendingPausedException$ = [-3, n0, _SPE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(SendingPausedException$, SendingPausedException);
export var TooManyRequestsException$ = [-3, n0, _TMRE,
    { [_e]: _c, [_hE]: 429 },
    [_m],
    [0]
];
n0_registry.registerError(TooManyRequestsException$, TooManyRequestsException);
export const errorTypeRegistries = [
    _s_registry,
    n0_registry,
];
var AdditionalContactEmailAddress = [0, n0, _ACEA, 8, 0];
var EmailSubject = [0, n0, _ES, 8, 0];
var InsightsEmailAddress = [0, n0, _IEA, 8, 0];
var PrivateKey = [0, n0, _PK, 8, 0];
var UseCaseDescription = [0, n0, _UCD, 8, 0];
var WebsiteURL = [0, n0, _WURL, 8, 0];
export var AccountDetails$ = [3, n0, _AD,
    0,
    [_MT, _WURL, _CL, _UCD, _ACEAd, _RD],
    [0, [() => WebsiteURL, 0], 0, [() => UseCaseDescription, 0], [() => AdditionalContactEmailAddresses, 0], () => ReviewDetails$]
];
export var ArchivingOptions$ = [3, n0, _AO,
    0,
    [_AA],
    [0]
];
export var Attachment$ = [3, n0, _A,
    0,
    [_RC, _FN, _CD, _CDo, _CI, _CTE, _CT],
    [21, 0, 0, 0, 0, 0, 0], 2
];
export var BatchGetMetricDataQuery$ = [3, n0, _BGMDQ,
    0,
    [_I, _N, _M, _SD, _ED, _D],
    [0, 0, 0, 4, 4, 128 | 0], 5
];
export var BatchGetMetricDataRequest$ = [3, n0, _BGMDR,
    0,
    [_Q],
    [() => BatchGetMetricDataQueries], 1
];
export var BatchGetMetricDataResponse$ = [3, n0, _BGMDRa,
    0,
    [_R, _E],
    [() => MetricDataResultList, () => MetricDataErrorList]
];
export var BlacklistEntry$ = [3, n0, _BE,
    0,
    [_RN, _LT, _De],
    [0, 4, 0]
];
export var Body$ = [3, n0, _B,
    0,
    [_T, _H],
    [() => Content$, () => Content$]
];
export var Bounce$ = [3, n0, _Bo,
    0,
    [_BT, _BST, _DC],
    [0, 0, 0]
];
export var BulkEmailContent$ = [3, n0, _BEC,
    0,
    [_Te],
    [() => Template$]
];
export var BulkEmailEntry$ = [3, n0, _BEE,
    0,
    [_Des, _RT, _REC, _RH],
    [() => Destination$, () => MessageTagList, () => ReplacementEmailContent$, () => MessageHeaderList], 1
];
export var BulkEmailEntryResult$ = [3, n0, _BEER,
    0,
    [_S, _Er, _MI],
    [0, 0, 0]
];
export var CancelExportJobRequest$ = [3, n0, _CEJR,
    0,
    [_JI],
    [[0, 1]], 1
];
export var CancelExportJobResponse$ = [3, n0, _CEJRa,
    0,
    [],
    []
];
export var CloudWatchDestination$ = [3, n0, _CWD,
    0,
    [_DCi],
    [() => CloudWatchDimensionConfigurations], 1
];
export var CloudWatchDimensionConfiguration$ = [3, n0, _CWDC,
    0,
    [_DN, _DVS, _DDV],
    [0, 0, 0], 3
];
export var Complaint$ = [3, n0, _C,
    0,
    [_CST, _CFT],
    [0, 0]
];
export var Contact$ = [3, n0, _Co,
    0,
    [_EA, _TP, _TDP, _UA, _LUT],
    [0, () => TopicPreferenceList, () => TopicPreferenceList, 2, 4]
];
export var ContactList$ = [3, n0, _CLo,
    0,
    [_CLN, _LUT],
    [0, 4]
];
export var ContactListDestination$ = [3, n0, _CLD,
    0,
    [_CLN, _CLIA],
    [0, 0], 2
];
export var Content$ = [3, n0, _Con,
    0,
    [_Da, _Ch],
    [0, 0], 1
];
export var CreateConfigurationSetEventDestinationRequest$ = [3, n0, _CCSEDR,
    0,
    [_CSN, _EDN, _EDv],
    [[0, 1], 0, () => EventDestinationDefinition$], 3
];
export var CreateConfigurationSetEventDestinationResponse$ = [3, n0, _CCSEDRr,
    0,
    [],
    []
];
export var CreateConfigurationSetRequest$ = [3, n0, _CCSR,
    0,
    [_CSN, _TO, _DO, _RO, _SO, _Ta, _SOu, _VO, _AO],
    [0, () => TrackingOptions$, () => DeliveryOptions$, () => ReputationOptions$, () => SendingOptions$, () => TagList, () => SuppressionOptions$, () => VdmOptions$, () => ArchivingOptions$], 1
];
export var CreateConfigurationSetResponse$ = [3, n0, _CCSRr,
    0,
    [],
    []
];
export var CreateContactListRequest$ = [3, n0, _CCLR,
    0,
    [_CLN, _To, _De, _Ta],
    [0, () => Topics, 0, () => TagList], 1
];
export var CreateContactListResponse$ = [3, n0, _CCLRr,
    0,
    [],
    []
];
export var CreateContactRequest$ = [3, n0, _CCR,
    0,
    [_CLN, _EA, _TP, _UA, _ADt],
    [[0, 1], 0, () => TopicPreferenceList, 2, 0], 2
];
export var CreateContactResponse$ = [3, n0, _CCRr,
    0,
    [],
    []
];
export var CreateCustomVerificationEmailTemplateRequest$ = [3, n0, _CCVETR,
    0,
    [_TN, _FEA, _TS, _TC, _SRURL, _FRURL, _Ta],
    [0, 0, 0, 0, 0, 0, () => TagList], 6
];
export var CreateCustomVerificationEmailTemplateResponse$ = [3, n0, _CCVETRr,
    0,
    [],
    []
];
export var CreateDedicatedIpPoolRequest$ = [3, n0, _CDIPR,
    0,
    [_PN, _Ta, _SM],
    [0, () => TagList, 0], 1
];
export var CreateDedicatedIpPoolResponse$ = [3, n0, _CDIPRr,
    0,
    [],
    []
];
export var CreateDeliverabilityTestReportRequest$ = [3, n0, _CDTRR,
    0,
    [_FEA, _Con, _RNe, _Ta],
    [0, () => EmailContent$, 0, () => TagList], 2
];
export var CreateDeliverabilityTestReportResponse$ = [3, n0, _CDTRRr,
    0,
    [_RI, _DTS],
    [0, 0], 2
];
export var CreateEmailIdentityPolicyRequest$ = [3, n0, _CEIPR,
    0,
    [_EI, _PNo, _P],
    [[0, 1], [0, 1], 0], 3
];
export var CreateEmailIdentityPolicyResponse$ = [3, n0, _CEIPRr,
    0,
    [],
    []
];
export var CreateEmailIdentityRequest$ = [3, n0, _CEIR,
    0,
    [_EI, _Ta, _DSA, _CSN],
    [0, () => TagList, [() => DkimSigningAttributes$, 0], 0], 1
];
export var CreateEmailIdentityResponse$ = [3, n0, _CEIRr,
    0,
    [_IT, _VFSS, _DA],
    [0, 2, () => DkimAttributes$]
];
export var CreateEmailTemplateRequest$ = [3, n0, _CETR,
    0,
    [_TN, _TC, _Ta],
    [0, () => EmailTemplateContent$, () => TagList], 2
];
export var CreateEmailTemplateResponse$ = [3, n0, _CETRr,
    0,
    [],
    []
];
export var CreateExportJobRequest$ = [3, n0, _CEJRr,
    0,
    [_EDS, _EDx],
    [[() => ExportDataSource$, 0], () => ExportDestination$], 2
];
export var CreateExportJobResponse$ = [3, n0, _CEJRre,
    0,
    [_JI],
    [0]
];
export var CreateImportJobRequest$ = [3, n0, _CIJR,
    0,
    [_ID, _IDS],
    [() => ImportDestination$, () => ImportDataSource$], 2
];
export var CreateImportJobResponse$ = [3, n0, _CIJRr,
    0,
    [_JI],
    [0]
];
export var CreateMultiRegionEndpointRequest$ = [3, n0, _CMRER,
    0,
    [_EN, _Det, _Ta],
    [0, () => Details$, () => TagList], 2
];
export var CreateMultiRegionEndpointResponse$ = [3, n0, _CMRERr,
    0,
    [_S, _EIn],
    [0, 0]
];
export var CreateTenantRequest$ = [3, n0, _CTR,
    0,
    [_TNe, _Ta, _SA],
    [0, () => TagList, () => TenantSuppressionAttributes$], 1
];
export var CreateTenantResourceAssociationRequest$ = [3, n0, _CTRAR,
    0,
    [_TNe, _RA],
    [0, 0], 2
];
export var CreateTenantResourceAssociationResponse$ = [3, n0, _CTRARr,
    0,
    [],
    []
];
export var CreateTenantResponse$ = [3, n0, _CTRr,
    0,
    [_TNe, _TI, _TA, _CTr, _Ta, _SS, _SA],
    [0, 0, 0, 4, () => TagList, 0, () => TenantSuppressionAttributes$]
];
export var CustomVerificationEmailTemplateMetadata$ = [3, n0, _CVETM,
    0,
    [_TN, _FEA, _TS, _SRURL, _FRURL],
    [0, 0, 0, 0, 0]
];
export var DailyVolume$ = [3, n0, _DV,
    0,
    [_SD, _VS, _DIP],
    [4, () => VolumeStatistics$, () => DomainIspPlacements]
];
export var DashboardAttributes$ = [3, n0, _DAa,
    0,
    [_EM],
    [0]
];
export var DashboardOptions$ = [3, n0, _DOa,
    0,
    [_EM],
    [0]
];
export var DedicatedIp$ = [3, n0, _DI,
    0,
    [_Ip, _WS, _WP, _PN],
    [0, 0, 1, 0], 3
];
export var DedicatedIpPool$ = [3, n0, _DIPe,
    0,
    [_PN, _SM],
    [0, 0], 2
];
export var DeleteConfigurationSetEventDestinationRequest$ = [3, n0, _DCSEDR,
    0,
    [_CSN, _EDN],
    [[0, 1], [0, 1]], 2
];
export var DeleteConfigurationSetEventDestinationResponse$ = [3, n0, _DCSEDRe,
    0,
    [],
    []
];
export var DeleteConfigurationSetRequest$ = [3, n0, _DCSR,
    0,
    [_CSN],
    [[0, 1]], 1
];
export var DeleteConfigurationSetResponse$ = [3, n0, _DCSRe,
    0,
    [],
    []
];
export var DeleteContactListRequest$ = [3, n0, _DCLR,
    0,
    [_CLN],
    [[0, 1]], 1
];
export var DeleteContactListResponse$ = [3, n0, _DCLRe,
    0,
    [],
    []
];
export var DeleteContactRequest$ = [3, n0, _DCR,
    0,
    [_CLN, _EA],
    [[0, 1], [0, 1]], 2
];
export var DeleteContactResponse$ = [3, n0, _DCRe,
    0,
    [],
    []
];
export var DeleteCustomVerificationEmailTemplateRequest$ = [3, n0, _DCVETR,
    0,
    [_TN],
    [[0, 1]], 1
];
export var DeleteCustomVerificationEmailTemplateResponse$ = [3, n0, _DCVETRe,
    0,
    [],
    []
];
export var DeleteDedicatedIpPoolRequest$ = [3, n0, _DDIPR,
    0,
    [_PN],
    [[0, 1]], 1
];
export var DeleteDedicatedIpPoolResponse$ = [3, n0, _DDIPRe,
    0,
    [],
    []
];
export var DeleteEmailIdentityPolicyRequest$ = [3, n0, _DEIPR,
    0,
    [_EI, _PNo],
    [[0, 1], [0, 1]], 2
];
export var DeleteEmailIdentityPolicyResponse$ = [3, n0, _DEIPRe,
    0,
    [],
    []
];
export var DeleteEmailIdentityRequest$ = [3, n0, _DEIR,
    0,
    [_EI],
    [[0, 1]], 1
];
export var DeleteEmailIdentityResponse$ = [3, n0, _DEIRe,
    0,
    [],
    []
];
export var DeleteEmailTemplateRequest$ = [3, n0, _DETR,
    0,
    [_TN],
    [[0, 1]], 1
];
export var DeleteEmailTemplateResponse$ = [3, n0, _DETRe,
    0,
    [],
    []
];
export var DeleteMultiRegionEndpointRequest$ = [3, n0, _DMRER,
    0,
    [_EN],
    [[0, 1]], 1
];
export var DeleteMultiRegionEndpointResponse$ = [3, n0, _DMRERe,
    0,
    [_S],
    [0]
];
export var DeleteSuppressedDestinationRequest$ = [3, n0, _DSDR,
    0,
    [_EA, _TNe],
    [[0, 1], [0, { [_hQ]: _TNe }]], 1
];
export var DeleteSuppressedDestinationResponse$ = [3, n0, _DSDRe,
    0,
    [],
    []
];
export var DeleteTenantRequest$ = [3, n0, _DTR,
    0,
    [_TNe],
    [0], 1
];
export var DeleteTenantResourceAssociationRequest$ = [3, n0, _DTRAR,
    0,
    [_TNe, _RA],
    [0, 0], 2
];
export var DeleteTenantResourceAssociationResponse$ = [3, n0, _DTRARe,
    0,
    [],
    []
];
export var DeleteTenantResponse$ = [3, n0, _DTRe,
    0,
    [],
    []
];
export var DeliverabilityTestReport$ = [3, n0, _DTRel,
    0,
    [_RI, _RNe, _Su, _FEA, _CDr, _DTS],
    [0, 0, 0, 0, 4, 0]
];
export var DeliveryOptions$ = [3, n0, _DO,
    0,
    [_TPl, _SPN, _MDS],
    [0, 0, 1]
];
export var Destination$ = [3, n0, _Des,
    0,
    [_TAo, _CA, _BA],
    [64 | 0, 64 | 0, 64 | 0]
];
export var Details$ = [3, n0, _Det,
    0,
    [_RDo],
    [() => RoutesDetails], 1
];
export var DkimAttributes$ = [3, n0, _DA,
    0,
    [_SE, _S, _Tok, _SHZ, _SAO, _NSKL, _CSKL, _LKGT],
    [2, 0, 64 | 0, 0, 0, 0, 0, 4]
];
export var DkimSigningAttributes$ = [3, n0, _DSA,
    0,
    [_DSS, _DSPK, _NSKL, _DSAO],
    [0, [() => PrivateKey, 0], 0, 0]
];
export var DomainDeliverabilityCampaign$ = [3, n0, _DDC,
    0,
    [_CIa, _IU, _Su, _FA, _SI, _FSDT, _LSDT, _IC, _SC, _RR, _DR, _RDR, _PV, _Es],
    [0, 0, 0, 0, 64 | 0, 4, 4, 1, 1, 1, 1, 1, 1, 64 | 0]
];
export var DomainDeliverabilityTrackingOption$ = [3, n0, _DDTO,
    0,
    [_Do, _SSD, _IPTO],
    [0, 4, () => InboxPlacementTrackingOption$]
];
export var DomainIspPlacement$ = [3, n0, _DIPo,
    0,
    [_IN, _IRC, _SRC, _IP, _SP],
    [0, 1, 1, 1, 1]
];
export var EmailAddressInsightsMailboxEvaluations$ = [3, n0, _EAIME,
    0,
    [_HVS, _HVDR, _ME, _IRA, _IDs, _IRI],
    [() => EmailAddressInsightsVerdict$, () => EmailAddressInsightsVerdict$, () => EmailAddressInsightsVerdict$, () => EmailAddressInsightsVerdict$, () => EmailAddressInsightsVerdict$, () => EmailAddressInsightsVerdict$]
];
export var EmailAddressInsightsVerdict$ = [3, n0, _EAIV,
    0,
    [_CV],
    [0]
];
export var EmailContent$ = [3, n0, _EC,
    0,
    [_Si, _Ra, _Te],
    [() => Message$, () => RawMessage$, () => Template$]
];
export var EmailInsights$ = [3, n0, _EIm,
    0,
    [_Des, _Is, _Ev],
    [[() => InsightsEmailAddress, 0], 0, () => InsightsEvents]
];
export var EmailTemplateContent$ = [3, n0, _ETC,
    0,
    [_Su, _T, _H],
    [0, 0, 0]
];
export var EmailTemplateMetadata$ = [3, n0, _ETM,
    0,
    [_TN, _CTr],
    [0, 4]
];
export var EventBridgeDestination$ = [3, n0, _EBD,
    0,
    [_EBA],
    [0], 1
];
export var EventDestination$ = [3, n0, _EDv,
    0,
    [_Na, _MET, _En, _KFD, _CWD, _SDn, _EBD, _PD],
    [0, 64 | 0, 2, () => KinesisFirehoseDestination$, () => CloudWatchDestination$, () => SnsDestination$, () => EventBridgeDestination$, () => PinpointDestination$], 2
];
export var EventDestinationDefinition$ = [3, n0, _EDD,
    0,
    [_En, _MET, _KFD, _CWD, _SDn, _EBD, _PD],
    [2, 64 | 0, () => KinesisFirehoseDestination$, () => CloudWatchDestination$, () => SnsDestination$, () => EventBridgeDestination$, () => PinpointDestination$]
];
export var EventDetails$ = [3, n0, _EDve,
    0,
    [_Bo, _C],
    [() => Bounce$, () => Complaint$]
];
export var ExportDataSource$ = [3, n0, _EDS,
    0,
    [_MDSe, _MIDS],
    [() => MetricsDataSource$, [() => MessageInsightsDataSource$, 0]]
];
export var ExportDestination$ = [3, n0, _EDx,
    0,
    [_DF, _SU],
    [0, 0], 1
];
export var ExportJobSummary$ = [3, n0, _EJS,
    0,
    [_JI, _EST, _JS, _CTr, _CTo],
    [0, 0, 0, 4, 4]
];
export var ExportMetric$ = [3, n0, _EMx,
    0,
    [_Na, _Ag],
    [0, 0]
];
export var ExportStatistics$ = [3, n0, _ESx,
    0,
    [_PRC, _ERC],
    [1, 1]
];
export var FailureInfo$ = [3, n0, _FI,
    0,
    [_FRSU, _EMr],
    [0, 0]
];
export var GetAccountRequest$ = [3, n0, _GAR,
    0,
    [],
    []
];
export var GetAccountResponse$ = [3, n0, _GARe,
    0,
    [_DIAWE, _ESn, _PAE, _SQ, _SEe, _SA, _Det, _VA, _PA],
    [2, 0, 2, () => SendQuota$, 2, () => SuppressionAttributes$, [() => AccountDetails$, 0], () => VdmAttributes$, () => PricingAttributes$]
];
export var GetBlacklistReportsRequest$ = [3, n0, _GBRR,
    0,
    [_BIN],
    [[64 | 0, { [_hQ]: _BIN }]], 1
];
export var GetBlacklistReportsResponse$ = [3, n0, _GBRRe,
    0,
    [_BR],
    [() => BlacklistReport], 1
];
export var GetConfigurationSetEventDestinationsRequest$ = [3, n0, _GCSEDR,
    0,
    [_CSN],
    [[0, 1]], 1
];
export var GetConfigurationSetEventDestinationsResponse$ = [3, n0, _GCSEDRe,
    0,
    [_EDven],
    [() => EventDestinations]
];
export var GetConfigurationSetRequest$ = [3, n0, _GCSR,
    0,
    [_CSN],
    [[0, 1]], 1
];
export var GetConfigurationSetResponse$ = [3, n0, _GCSRe,
    0,
    [_CSN, _TO, _DO, _RO, _SO, _Ta, _SOu, _VO, _AO],
    [0, () => TrackingOptions$, () => DeliveryOptions$, () => ReputationOptions$, () => SendingOptions$, () => TagList, () => SuppressionOptions$, () => VdmOptions$, () => ArchivingOptions$]
];
export var GetContactListRequest$ = [3, n0, _GCLR,
    0,
    [_CLN],
    [[0, 1]], 1
];
export var GetContactListResponse$ = [3, n0, _GCLRe,
    0,
    [_CLN, _To, _De, _CTr, _LUT, _Ta],
    [0, () => Topics, 0, 4, 4, () => TagList]
];
export var GetContactRequest$ = [3, n0, _GCR,
    0,
    [_CLN, _EA],
    [[0, 1], [0, 1]], 2
];
export var GetContactResponse$ = [3, n0, _GCRe,
    0,
    [_CLN, _EA, _TP, _TDP, _UA, _ADt, _CTr, _LUT],
    [0, 0, () => TopicPreferenceList, () => TopicPreferenceList, 2, 0, 4, 4]
];
export var GetCustomVerificationEmailTemplateRequest$ = [3, n0, _GCVETR,
    0,
    [_TN],
    [[0, 1]], 1
];
export var GetCustomVerificationEmailTemplateResponse$ = [3, n0, _GCVETRe,
    0,
    [_TN, _FEA, _TS, _TC, _Ta, _SRURL, _FRURL],
    [0, 0, 0, 0, () => TagList, 0, 0]
];
export var GetDedicatedIpPoolRequest$ = [3, n0, _GDIPR,
    0,
    [_PN],
    [[0, 1]], 1
];
export var GetDedicatedIpPoolResponse$ = [3, n0, _GDIPRe,
    0,
    [_DIPe],
    [() => DedicatedIpPool$]
];
export var GetDedicatedIpRequest$ = [3, n0, _GDIR,
    0,
    [_Ip],
    [[0, 1]], 1
];
export var GetDedicatedIpResponse$ = [3, n0, _GDIRe,
    0,
    [_DI],
    [() => DedicatedIp$]
];
export var GetDedicatedIpsRequest$ = [3, n0, _GDIRet,
    0,
    [_PN, _NT, _PS],
    [[0, { [_hQ]: _PN }], [0, { [_hQ]: _NT }], [1, { [_hQ]: _PS }]]
];
export var GetDedicatedIpsResponse$ = [3, n0, _GDIRete,
    0,
    [_DIe, _NT],
    [() => DedicatedIpList, 0]
];
export var GetDeliverabilityDashboardOptionsRequest$ = [3, n0, _GDDOR,
    0,
    [],
    []
];
export var GetDeliverabilityDashboardOptionsResponse$ = [3, n0, _GDDORe,
    0,
    [_DE, _SED, _AS, _ASD, _PESD],
    [2, 4, 0, () => DomainDeliverabilityTrackingOptions, () => DomainDeliverabilityTrackingOptions], 1
];
export var GetDeliverabilityTestReportRequest$ = [3, n0, _GDTRR,
    0,
    [_RI],
    [[0, 1]], 1
];
export var GetDeliverabilityTestReportResponse$ = [3, n0, _GDTRRe,
    0,
    [_DTRel, _OP, _IPs, _Me, _Ta],
    [() => DeliverabilityTestReport$, () => PlacementStatistics$, () => IspPlacements, 0, () => TagList], 3
];
export var GetDomainDeliverabilityCampaignRequest$ = [3, n0, _GDDCR,
    0,
    [_CIa],
    [[0, 1]], 1
];
export var GetDomainDeliverabilityCampaignResponse$ = [3, n0, _GDDCRe,
    0,
    [_DDC],
    [() => DomainDeliverabilityCampaign$], 1
];
export var GetDomainStatisticsReportRequest$ = [3, n0, _GDSRR,
    0,
    [_Do, _SD, _ED],
    [[0, 1], [4, { [_hQ]: _SD }], [4, { [_hQ]: _ED }]], 3
];
export var GetDomainStatisticsReportResponse$ = [3, n0, _GDSRRe,
    0,
    [_OV, _DVa],
    [() => OverallVolume$, () => DailyVolumes], 2
];
export var GetEmailAddressInsightsRequest$ = [3, n0, _GEAIR,
    0,
    [_EA],
    [0], 1
];
export var GetEmailAddressInsightsResponse$ = [3, n0, _GEAIRe,
    0,
    [_MV],
    [() => MailboxValidation$]
];
export var GetEmailIdentityPoliciesRequest$ = [3, n0, _GEIPR,
    0,
    [_EI],
    [[0, 1]], 1
];
export var GetEmailIdentityPoliciesResponse$ = [3, n0, _GEIPRe,
    0,
    [_Po],
    [128 | 0]
];
export var GetEmailIdentityRequest$ = [3, n0, _GEIR,
    0,
    [_EI],
    [[0, 1]], 1
];
export var GetEmailIdentityResponse$ = [3, n0, _GEIRe,
    0,
    [_IT, _FFS, _VFSS, _DA, _MFA, _Po, _Ta, _CSN, _VSe, _VI],
    [0, 2, 2, () => DkimAttributes$, () => MailFromAttributes$, 128 | 0, () => TagList, 0, 0, () => VerificationInfo$]
];
export var GetEmailTemplateRequest$ = [3, n0, _GETR,
    0,
    [_TN],
    [[0, 1]], 1
];
export var GetEmailTemplateResponse$ = [3, n0, _GETRe,
    0,
    [_TN, _TC, _Ta],
    [0, () => EmailTemplateContent$, () => TagList], 2
];
export var GetExportJobRequest$ = [3, n0, _GEJR,
    0,
    [_JI],
    [[0, 1]], 1
];
export var GetExportJobResponse$ = [3, n0, _GEJRe,
    0,
    [_JI, _EST, _JS, _EDx, _EDS, _CTr, _CTo, _FI, _St],
    [0, 0, 0, () => ExportDestination$, [() => ExportDataSource$, 0], 4, 4, () => FailureInfo$, () => ExportStatistics$]
];
export var GetImportJobRequest$ = [3, n0, _GIJR,
    0,
    [_JI],
    [[0, 1]], 1
];
export var GetImportJobResponse$ = [3, n0, _GIJRe,
    0,
    [_JI, _ID, _IDS, _FI, _JS, _CTr, _CTo, _PRC, _FRC],
    [0, () => ImportDestination$, () => ImportDataSource$, () => FailureInfo$, 0, 4, 4, 1, 1]
];
export var GetMessageInsightsRequest$ = [3, n0, _GMIR,
    0,
    [_MI],
    [[0, 1]], 1
];
export var GetMessageInsightsResponse$ = [3, n0, _GMIRe,
    0,
    [_MI, _FEA, _Su, _ET, _In],
    [0, [() => InsightsEmailAddress, 0], [() => EmailSubject, 0], () => MessageTagList, [() => EmailInsightsList, 0]]
];
export var GetMultiRegionEndpointRequest$ = [3, n0, _GMRER,
    0,
    [_EN],
    [[0, 1]], 1
];
export var GetMultiRegionEndpointResponse$ = [3, n0, _GMRERe,
    0,
    [_EN, _EIn, _Ro, _S, _CTr, _LUT],
    [0, 0, () => Routes, 0, 4, 4]
];
export var GetReputationEntityRequest$ = [3, n0, _GRER,
    0,
    [_RER, _RET],
    [[0, 1], [0, 1]], 2
];
export var GetReputationEntityResponse$ = [3, n0, _GRERe,
    0,
    [_RE],
    [() => ReputationEntity$]
];
export var GetSuppressedDestinationRequest$ = [3, n0, _GSDR,
    0,
    [_EA, _TNe],
    [[0, 1], [0, { [_hQ]: _TNe }]], 1
];
export var GetSuppressedDestinationResponse$ = [3, n0, _GSDRe,
    0,
    [_SDu],
    [() => SuppressedDestination$], 1
];
export var GetTenantRequest$ = [3, n0, _GTR,
    0,
    [_TNe],
    [0], 1
];
export var GetTenantResponse$ = [3, n0, _GTRe,
    0,
    [_Ten],
    [() => Tenant$]
];
export var GuardianAttributes$ = [3, n0, _GA,
    0,
    [_OSD],
    [0]
];
export var GuardianOptions$ = [3, n0, _GO,
    0,
    [_OSD],
    [0]
];
export var IdentityInfo$ = [3, n0, _II,
    0,
    [_IT, _INd, _SEe, _VSe],
    [0, 0, 2, 0]
];
export var ImportDataSource$ = [3, n0, _IDS,
    0,
    [_SU, _DF],
    [0, 0], 2
];
export var ImportDestination$ = [3, n0, _ID,
    0,
    [_SLD, _CLD],
    [() => SuppressionListDestination$, () => ContactListDestination$]
];
export var ImportJobSummary$ = [3, n0, _IJS,
    0,
    [_JI, _ID, _JS, _CTr, _PRC, _FRC],
    [0, () => ImportDestination$, 0, 4, 1, 1]
];
export var InboxPlacementTrackingOption$ = [3, n0, _IPTO,
    0,
    [_G, _TIr],
    [2, 64 | 0]
];
export var InsightsEvent$ = [3, n0, _IE,
    0,
    [_Ti, _Ty, _Det],
    [4, 0, () => EventDetails$]
];
export var IspPlacement$ = [3, n0, _IPsp,
    0,
    [_IN, _PSl],
    [0, () => PlacementStatistics$]
];
export var KinesisFirehoseDestination$ = [3, n0, _KFD,
    0,
    [_IRAa, _DSAe],
    [0, 0], 2
];
export var ListConfigurationSetsRequest$ = [3, n0, _LCSR,
    0,
    [_NT, _PS],
    [[0, { [_hQ]: _NT }], [1, { [_hQ]: _PS }]]
];
export var ListConfigurationSetsResponse$ = [3, n0, _LCSRi,
    0,
    [_CS, _NT],
    [64 | 0, 0]
];
export var ListContactListsRequest$ = [3, n0, _LCLR,
    0,
    [_PS, _NT],
    [[1, { [_hQ]: _PS }], [0, { [_hQ]: _NT }]]
];
export var ListContactListsResponse$ = [3, n0, _LCLRi,
    0,
    [_CLon, _NT],
    [() => ListOfContactLists, 0]
];
export var ListContactsFilter$ = [3, n0, _LCF,
    0,
    [_FS, _TF],
    [0, () => TopicFilter$]
];
export var ListContactsRequest$ = [3, n0, _LCR,
    0,
    [_CLN, _F, _PS, _NT],
    [[0, 1], () => ListContactsFilter$, 1, 0], 1
];
export var ListContactsResponse$ = [3, n0, _LCRi,
    0,
    [_Cont, _NT],
    [() => ListOfContacts, 0]
];
export var ListCustomVerificationEmailTemplatesRequest$ = [3, n0, _LCVETR,
    0,
    [_NT, _PS],
    [[0, { [_hQ]: _NT }], [1, { [_hQ]: _PS }]]
];
export var ListCustomVerificationEmailTemplatesResponse$ = [3, n0, _LCVETRi,
    0,
    [_CVET, _NT],
    [() => CustomVerificationEmailTemplatesList, 0]
];
export var ListDedicatedIpPoolsRequest$ = [3, n0, _LDIPR,
    0,
    [_NT, _PS],
    [[0, { [_hQ]: _NT }], [1, { [_hQ]: _PS }]]
];
export var ListDedicatedIpPoolsResponse$ = [3, n0, _LDIPRi,
    0,
    [_DIPed, _NT],
    [64 | 0, 0]
];
export var ListDeliverabilityTestReportsRequest$ = [3, n0, _LDTRR,
    0,
    [_NT, _PS],
    [[0, { [_hQ]: _NT }], [1, { [_hQ]: _PS }]]
];
export var ListDeliverabilityTestReportsResponse$ = [3, n0, _LDTRRi,
    0,
    [_DTReli, _NT],
    [() => DeliverabilityTestReports, 0], 1
];
export var ListDomainDeliverabilityCampaignsRequest$ = [3, n0, _LDDCR,
    0,
    [_SD, _ED, _SDub, _NT, _PS],
    [[4, { [_hQ]: _SD }], [4, { [_hQ]: _ED }], [0, 1], [0, { [_hQ]: _NT }], [1, { [_hQ]: _PS }]], 3
];
export var ListDomainDeliverabilityCampaignsResponse$ = [3, n0, _LDDCRi,
    0,
    [_DDCo, _NT],
    [() => DomainDeliverabilityCampaignList, 0], 1
];
export var ListEmailIdentitiesRequest$ = [3, n0, _LEIR,
    0,
    [_NT, _PS],
    [[0, { [_hQ]: _NT }], [1, { [_hQ]: _PS }]]
];
export var ListEmailIdentitiesResponse$ = [3, n0, _LEIRi,
    0,
    [_EIma, _NT],
    [() => IdentityInfoList, 0]
];
export var ListEmailTemplatesRequest$ = [3, n0, _LETR,
    0,
    [_NT, _PS],
    [[0, { [_hQ]: _NT }], [1, { [_hQ]: _PS }]]
];
export var ListEmailTemplatesResponse$ = [3, n0, _LETRi,
    0,
    [_TM, _NT],
    [() => EmailTemplateMetadataList, 0]
];
export var ListExportJobsRequest$ = [3, n0, _LEJR,
    0,
    [_NT, _PS, _EST, _JS],
    [0, 1, 0, 0]
];
export var ListExportJobsResponse$ = [3, n0, _LEJRi,
    0,
    [_EJ, _NT],
    [() => ExportJobSummaryList, 0]
];
export var ListImportJobsRequest$ = [3, n0, _LIJR,
    0,
    [_IDT, _NT, _PS],
    [0, 0, 1]
];
export var ListImportJobsResponse$ = [3, n0, _LIJRi,
    0,
    [_IJ, _NT],
    [() => ImportJobSummaryList, 0]
];
export var ListManagementOptions$ = [3, n0, _LMO,
    0,
    [_CLN, _TNo],
    [0, 0], 1
];
export var ListMultiRegionEndpointsRequest$ = [3, n0, _LMRER,
    0,
    [_NT, _PS],
    [[0, { [_hQ]: _NT }], [1, { [_hQ]: _PS }]]
];
export var ListMultiRegionEndpointsResponse$ = [3, n0, _LMRERi,
    0,
    [_MRE, _NT],
    [() => MultiRegionEndpoints, 0]
];
export var ListRecommendationsRequest$ = [3, n0, _LRR,
    0,
    [_F, _NT, _PS],
    [128 | 0, 0, 1]
];
export var ListRecommendationsResponse$ = [3, n0, _LRRi,
    0,
    [_Re, _NT],
    [() => RecommendationsList, 0]
];
export var ListReputationEntitiesRequest$ = [3, n0, _LRER,
    0,
    [_F, _NT, _PS],
    [128 | 0, 0, 1]
];
export var ListReputationEntitiesResponse$ = [3, n0, _LRERi,
    0,
    [_REe, _NT],
    [() => ReputationEntitiesList, 0]
];
export var ListResourceTenantsRequest$ = [3, n0, _LRTR,
    0,
    [_RA, _PS, _NT],
    [0, 1, 0], 1
];
export var ListResourceTenantsResponse$ = [3, n0, _LRTRi,
    0,
    [_RTe, _NT],
    [() => ResourceTenantMetadataList, 0]
];
export var ListSuppressedDestinationsRequest$ = [3, n0, _LSDR,
    0,
    [_TNe, _Rea, _SD, _ED, _NT, _PS],
    [[0, { [_hQ]: _TNe }], [64 | 0, { [_hQ]: _Reas }], [4, { [_hQ]: _SD }], [4, { [_hQ]: _ED }], [0, { [_hQ]: _NT }], [1, { [_hQ]: _PS }]]
];
export var ListSuppressedDestinationsResponse$ = [3, n0, _LSDRi,
    0,
    [_SDS, _NT],
    [() => SuppressedDestinationSummaries, 0]
];
export var ListTagsForResourceRequest$ = [3, n0, _LTFRR,
    0,
    [_RA],
    [[0, { [_hQ]: _RA }]], 1
];
export var ListTagsForResourceResponse$ = [3, n0, _LTFRRi,
    0,
    [_Ta],
    [() => TagList], 1
];
export var ListTenantResourcesRequest$ = [3, n0, _LTRR,
    0,
    [_TNe, _F, _PS, _NT],
    [0, 128 | 0, 1, 0], 1
];
export var ListTenantResourcesResponse$ = [3, n0, _LTRRi,
    0,
    [_TR, _NT],
    [() => TenantResourceList, 0]
];
export var ListTenantsRequest$ = [3, n0, _LTR,
    0,
    [_NT, _PS],
    [0, 1]
];
export var ListTenantsResponse$ = [3, n0, _LTRi,
    0,
    [_Tena, _NT],
    [() => TenantInfoList, 0]
];
export var MailboxValidation$ = [3, n0, _MV,
    0,
    [_IV, _Eva],
    [() => EmailAddressInsightsVerdict$, () => EmailAddressInsightsMailboxEvaluations$]
];
export var MailFromAttributes$ = [3, n0, _MFA,
    0,
    [_MFD, _MFDS, _BOMF],
    [0, 0, 0], 3
];
export var Message$ = [3, n0, _Me,
    0,
    [_Su, _B, _He, _At],
    [() => Content$, () => Body$, () => MessageHeaderList, () => AttachmentList], 2
];
export var MessageHeader$ = [3, n0, _MH,
    0,
    [_Na, _V],
    [0, 0], 2
];
export var MessageInsightsDataSource$ = [3, n0, _MIDS,
    0,
    [_SD, _ED, _Inc, _Ex, _MRa],
    [4, 4, [() => MessageInsightsFilters$, 0], [() => MessageInsightsFilters$, 0], 1], 2
];
export var MessageInsightsFilters$ = [3, n0, _MIF,
    0,
    [_FEA, _Des, _Su, _Is, _LDE, _LEEa],
    [[() => EmailAddressFilterList, 0], [() => EmailAddressFilterList, 0], [() => EmailSubjectFilterList, 0], 64 | 0, 64 | 0, 64 | 0]
];
export var MessageTag$ = [3, n0, _MTe,
    0,
    [_Na, _V],
    [0, 0], 2
];
export var MetricDataError$ = [3, n0, _MDE,
    0,
    [_I, _Cod, _Me],
    [0, 0, 0]
];
export var MetricDataResult$ = [3, n0, _MDR,
    0,
    [_I, _Tim, _Va],
    [0, 64 | 4, 64 | 1]
];
export var MetricsDataSource$ = [3, n0, _MDSe,
    0,
    [_D, _N, _Met, _SD, _ED],
    [[2, n0, _EDxp, 0, 0, 64 | 0], 0, () => ExportMetrics, 4, 4], 5
];
export var MultiRegionEndpoint$ = [3, n0, _MREu,
    0,
    [_EN, _S, _EIn, _Reg, _CTr, _LUT],
    [0, 0, 0, 64 | 0, 4, 4]
];
export var OverallVolume$ = [3, n0, _OV,
    0,
    [_VS, _RRP, _DIP],
    [() => VolumeStatistics$, 1, () => DomainIspPlacements]
];
export var PinpointDestination$ = [3, n0, _PD,
    0,
    [_AAp],
    [0]
];
export var PlacementStatistics$ = [3, n0, _PSl,
    0,
    [_IP, _SP, _MP, _SPp, _DP],
    [1, 1, 1, 1, 1]
];
export var PricingAttributes$ = [3, n0, _PA,
    0,
    [_CP, _NP],
    [0, 0]
];
export var PutAccountDedicatedIpWarmupAttributesRequest$ = [3, n0, _PADIWAR,
    0,
    [_AWE],
    [2]
];
export var PutAccountDedicatedIpWarmupAttributesResponse$ = [3, n0, _PADIWARu,
    0,
    [],
    []
];
export var PutAccountDetailsRequest$ = [3, n0, _PADR,
    0,
    [_MT, _WURL, _CL, _UCD, _ACEAd, _PAE],
    [0, [() => WebsiteURL, 0], 0, [() => UseCaseDescription, 0], [() => AdditionalContactEmailAddresses, 0], 2], 2
];
export var PutAccountDetailsResponse$ = [3, n0, _PADRu,
    0,
    [],
    []
];
export var PutAccountPricingAttributesRequest$ = [3, n0, _PAPAR,
    0,
    [_Pl],
    [0], 1
];
export var PutAccountPricingAttributesResponse$ = [3, n0, _PAPARu,
    0,
    [],
    []
];
export var PutAccountSendingAttributesRequest$ = [3, n0, _PASAR,
    0,
    [_SEe],
    [2]
];
export var PutAccountSendingAttributesResponse$ = [3, n0, _PASARu,
    0,
    [],
    []
];
export var PutAccountSuppressionAttributesRequest$ = [3, n0, _PASARut,
    0,
    [_SR, _VAa],
    [64 | 0, () => SuppressionValidationAttributes$]
];
export var PutAccountSuppressionAttributesResponse$ = [3, n0, _PASARutc,
    0,
    [],
    []
];
export var PutAccountVdmAttributesRequest$ = [3, n0, _PAVAR,
    0,
    [_VA],
    [() => VdmAttributes$], 1
];
export var PutAccountVdmAttributesResponse$ = [3, n0, _PAVARu,
    0,
    [],
    []
];
export var PutConfigurationSetArchivingOptionsRequest$ = [3, n0, _PCSAOR,
    0,
    [_CSN, _AA],
    [[0, 1], 0], 1
];
export var PutConfigurationSetArchivingOptionsResponse$ = [3, n0, _PCSAORu,
    0,
    [],
    []
];
export var PutConfigurationSetDeliveryOptionsRequest$ = [3, n0, _PCSDOR,
    0,
    [_CSN, _TPl, _SPN, _MDS],
    [[0, 1], 0, 0, 1], 1
];
export var PutConfigurationSetDeliveryOptionsResponse$ = [3, n0, _PCSDORu,
    0,
    [],
    []
];
export var PutConfigurationSetReputationOptionsRequest$ = [3, n0, _PCSROR,
    0,
    [_CSN, _RME],
    [[0, 1], 2], 1
];
export var PutConfigurationSetReputationOptionsResponse$ = [3, n0, _PCSRORu,
    0,
    [],
    []
];
export var PutConfigurationSetSendingOptionsRequest$ = [3, n0, _PCSSOR,
    0,
    [_CSN, _SEe],
    [[0, 1], 2], 1
];
export var PutConfigurationSetSendingOptionsResponse$ = [3, n0, _PCSSORu,
    0,
    [],
    []
];
export var PutConfigurationSetSuppressionOptionsRequest$ = [3, n0, _PCSSORut,
    0,
    [_CSN, _SSu, _SR, _VOa],
    [[0, 1], 0, 64 | 0, () => SuppressionValidationOptions$], 1
];
export var PutConfigurationSetSuppressionOptionsResponse$ = [3, n0, _PCSSORuto,
    0,
    [],
    []
];
export var PutConfigurationSetTrackingOptionsRequest$ = [3, n0, _PCSTOR,
    0,
    [_CSN, _CRD, _HP],
    [[0, 1], 0, 0], 1
];
export var PutConfigurationSetTrackingOptionsResponse$ = [3, n0, _PCSTORu,
    0,
    [],
    []
];
export var PutConfigurationSetVdmOptionsRequest$ = [3, n0, _PCSVOR,
    0,
    [_CSN, _VO],
    [[0, 1], () => VdmOptions$], 1
];
export var PutConfigurationSetVdmOptionsResponse$ = [3, n0, _PCSVORu,
    0,
    [],
    []
];
export var PutDedicatedIpInPoolRequest$ = [3, n0, _PDIIPR,
    0,
    [_Ip, _DPN],
    [[0, 1], 0], 2
];
export var PutDedicatedIpInPoolResponse$ = [3, n0, _PDIIPRu,
    0,
    [],
    []
];
export var PutDedicatedIpPoolScalingAttributesRequest$ = [3, n0, _PDIPSAR,
    0,
    [_PN, _SM],
    [[0, 1], 0], 2
];
export var PutDedicatedIpPoolScalingAttributesResponse$ = [3, n0, _PDIPSARu,
    0,
    [],
    []
];
export var PutDedicatedIpWarmupAttributesRequest$ = [3, n0, _PDIWAR,
    0,
    [_Ip, _WP],
    [[0, 1], 1], 2
];
export var PutDedicatedIpWarmupAttributesResponse$ = [3, n0, _PDIWARu,
    0,
    [],
    []
];
export var PutDeliverabilityDashboardOptionRequest$ = [3, n0, _PDDOR,
    0,
    [_DE, _SDubs],
    [2, () => DomainDeliverabilityTrackingOptions], 1
];
export var PutDeliverabilityDashboardOptionResponse$ = [3, n0, _PDDORu,
    0,
    [],
    []
];
export var PutEmailIdentityConfigurationSetAttributesRequest$ = [3, n0, _PEICSAR,
    0,
    [_EI, _CSN],
    [[0, 1], 0], 1
];
export var PutEmailIdentityConfigurationSetAttributesResponse$ = [3, n0, _PEICSARu,
    0,
    [],
    []
];
export var PutEmailIdentityDkimAttributesRequest$ = [3, n0, _PEIDAR,
    0,
    [_EI, _SE],
    [[0, 1], 2], 1
];
export var PutEmailIdentityDkimAttributesResponse$ = [3, n0, _PEIDARu,
    0,
    [],
    []
];
export var PutEmailIdentityDkimSigningAttributesRequest$ = [3, n0, _PEIDSAR,
    0,
    [_EI, _SAO, _SAi],
    [[0, 1], 0, [() => DkimSigningAttributes$, 0]], 2
];
export var PutEmailIdentityDkimSigningAttributesResponse$ = [3, n0, _PEIDSARu,
    0,
    [_DS, _DT, _SHZ],
    [0, 64 | 0, 0]
];
export var PutEmailIdentityFeedbackAttributesRequest$ = [3, n0, _PEIFAR,
    0,
    [_EI, _EFE],
    [[0, 1], 2], 1
];
export var PutEmailIdentityFeedbackAttributesResponse$ = [3, n0, _PEIFARu,
    0,
    [],
    []
];
export var PutEmailIdentityMailFromAttributesRequest$ = [3, n0, _PEIMFAR,
    0,
    [_EI, _MFD, _BOMF],
    [[0, 1], 0, 0], 1
];
export var PutEmailIdentityMailFromAttributesResponse$ = [3, n0, _PEIMFARu,
    0,
    [],
    []
];
export var PutSuppressedDestinationRequest$ = [3, n0, _PSDR,
    0,
    [_EA, _Reas, _TNe],
    [0, 0, 0], 2
];
export var PutSuppressedDestinationResponse$ = [3, n0, _PSDRu,
    0,
    [],
    []
];
export var PutTenantSuppressionAttributesRequest$ = [3, n0, _PTSAR,
    0,
    [_TNe, _SR, _SSu],
    [0, 64 | 0, 0], 1
];
export var PutTenantSuppressionAttributesResponse$ = [3, n0, _PTSARu,
    0,
    [],
    []
];
export var RawMessage$ = [3, n0, _RM,
    0,
    [_Da],
    [21], 1
];
export var Recommendation$ = [3, n0, _Rec,
    0,
    [_RA, _Ty, _De, _S, _CTr, _LUT, _Im],
    [0, 0, 0, 0, 4, 4, 0]
];
export var ReplacementEmailContent$ = [3, n0, _REC,
    0,
    [_RTep],
    [() => ReplacementTemplate$]
];
export var ReplacementTemplate$ = [3, n0, _RTep,
    0,
    [_RTD],
    [0]
];
export var ReputationEntity$ = [3, n0, _RE,
    0,
    [_RER, _RET, _RMP, _CMS, _ASMS, _SSA, _RIe],
    [0, 0, 0, () => StatusRecord$, () => StatusRecord$, 0, 0]
];
export var ReputationOptions$ = [3, n0, _RO,
    0,
    [_RME, _LFS],
    [2, 4]
];
export var ResourceTenantMetadata$ = [3, n0, _RTM,
    0,
    [_TNe, _TI, _RA, _AT],
    [0, 0, 0, 4]
];
export var ReviewDetails$ = [3, n0, _RD,
    0,
    [_S, _CIas],
    [0, 0]
];
export var Route$ = [3, n0, _Rou,
    0,
    [_Regi],
    [0], 1
];
export var RouteDetails$ = [3, n0, _RDou,
    0,
    [_Regi],
    [0], 1
];
export var SendBulkEmailRequest$ = [3, n0, _SBER,
    0,
    [_DCe, _BEEu, _FEA, _FEAIA, _RTA, _FFEA, _FFEAIA, _DET, _CSN, _EIn, _TNe],
    [() => BulkEmailContent$, () => BulkEmailEntryList, 0, 0, 64 | 0, 0, 0, () => MessageTagList, 0, 0, 0], 2
];
export var SendBulkEmailResponse$ = [3, n0, _SBERe,
    0,
    [_BEERu],
    [() => BulkEmailEntryResultList], 1
];
export var SendCustomVerificationEmailRequest$ = [3, n0, _SCVER,
    0,
    [_EA, _TN, _CSN],
    [0, 0, 0], 2
];
export var SendCustomVerificationEmailResponse$ = [3, n0, _SCVERe,
    0,
    [_MI],
    [0]
];
export var SendEmailRequest$ = [3, n0, _SER,
    0,
    [_Con, _FEA, _FEAIA, _Des, _RTA, _FFEA, _FFEAIA, _ET, _CSN, _EIn, _TNe, _LMO],
    [() => EmailContent$, 0, 0, () => Destination$, 64 | 0, 0, 0, () => MessageTagList, 0, 0, 0, () => ListManagementOptions$], 1
];
export var SendEmailResponse$ = [3, n0, _SERe,
    0,
    [_MI],
    [0]
];
export var SendingOptions$ = [3, n0, _SO,
    0,
    [_SEe],
    [2]
];
export var SendQuota$ = [3, n0, _SQ,
    0,
    [_MHS, _MSR, _SLH],
    [1, 1, 1]
];
export var SnsDestination$ = [3, n0, _SDn,
    0,
    [_TAop],
    [0], 1
];
export var SOARecord$ = [3, n0, _SOAR,
    0,
    [_PNS, _AE, _SN],
    [0, 0, 1]
];
export var StatusRecord$ = [3, n0, _SRt,
    0,
    [_S, _Ca, _LUT],
    [0, 0, 4]
];
export var SuppressedDestination$ = [3, n0, _SDu,
    0,
    [_EA, _Reas, _LUTa, _Att, _TNe],
    [0, 0, 4, () => SuppressedDestinationAttributes$, 0], 3
];
export var SuppressedDestinationAttributes$ = [3, n0, _SDA,
    0,
    [_MI, _FIe],
    [0, 0]
];
export var SuppressedDestinationSummary$ = [3, n0, _SDSu,
    0,
    [_EA, _Reas, _LUTa],
    [0, 0, 4], 3
];
export var SuppressionAttributes$ = [3, n0, _SA,
    0,
    [_SR, _VAa],
    [64 | 0, () => SuppressionValidationAttributes$]
];
export var SuppressionConditionThreshold$ = [3, n0, _SCT,
    0,
    [_CTEo, _OCT],
    [0, () => SuppressionConfidenceThreshold$], 1
];
export var SuppressionConfidenceThreshold$ = [3, n0, _SCTu,
    0,
    [_CVT],
    [0], 1
];
export var SuppressionListDestination$ = [3, n0, _SLD,
    0,
    [_SLIA],
    [0], 1
];
export var SuppressionOptions$ = [3, n0, _SOu,
    0,
    [_SR, _SSu, _VOa],
    [64 | 0, 0, () => SuppressionValidationOptions$]
];
export var SuppressionValidationAttributes$ = [3, n0, _SVA,
    0,
    [_CTon],
    [() => SuppressionConditionThreshold$], 1
];
export var SuppressionValidationOptions$ = [3, n0, _SVO,
    0,
    [_CTon],
    [() => SuppressionConditionThreshold$], 1
];
export var Tag$ = [3, n0, _Tag,
    0,
    [_K, _V],
    [0, 0], 2
];
export var TagResourceRequest$ = [3, n0, _TRR,
    0,
    [_RA, _Ta],
    [0, () => TagList], 2
];
export var TagResourceResponse$ = [3, n0, _TRRa,
    0,
    [],
    []
];
export var Template$ = [3, n0, _Te,
    0,
    [_TN, _TAe, _TC, _TD, _He, _At],
    [0, 0, () => EmailTemplateContent$, 0, () => MessageHeaderList, () => AttachmentList]
];
export var Tenant$ = [3, n0, _Ten,
    0,
    [_TNe, _TI, _TA, _CTr, _Ta, _SS, _SA],
    [0, 0, 0, 4, () => TagList, 0, () => TenantSuppressionAttributes$]
];
export var TenantInfo$ = [3, n0, _TIe,
    0,
    [_TNe, _TI, _TA, _CTr],
    [0, 0, 0, 4]
];
export var TenantResource$ = [3, n0, _TRe,
    0,
    [_RTes, _RA],
    [0, 0]
];
export var TenantSuppressionAttributes$ = [3, n0, _TSA,
    0,
    [_SR, _SSu],
    [64 | 0, 0]
];
export var TestRenderEmailTemplateRequest$ = [3, n0, _TRETR,
    0,
    [_TN, _TD],
    [[0, 1], 0], 2
];
export var TestRenderEmailTemplateResponse$ = [3, n0, _TRETRe,
    0,
    [_RTen],
    [0], 1
];
export var Topic$ = [3, n0, _Top,
    0,
    [_TNo, _DNi, _DSSe, _De],
    [0, 0, 0, 0], 3
];
export var TopicFilter$ = [3, n0, _TF,
    0,
    [_TNo, _UDIPU],
    [0, 2]
];
export var TopicPreference$ = [3, n0, _TPo,
    0,
    [_TNo, _SSub],
    [0, 0], 2
];
export var TrackingOptions$ = [3, n0, _TO,
    0,
    [_CRD, _HP],
    [0, 0], 1
];
export var UntagResourceRequest$ = [3, n0, _URR,
    0,
    [_RA, _TK],
    [[0, { [_hQ]: _RA }], [64 | 0, { [_hQ]: _TK }]], 2
];
export var UntagResourceResponse$ = [3, n0, _URRn,
    0,
    [],
    []
];
export var UpdateConfigurationSetEventDestinationRequest$ = [3, n0, _UCSEDR,
    0,
    [_CSN, _EDN, _EDv],
    [[0, 1], [0, 1], () => EventDestinationDefinition$], 3
];
export var UpdateConfigurationSetEventDestinationResponse$ = [3, n0, _UCSEDRp,
    0,
    [],
    []
];
export var UpdateContactListRequest$ = [3, n0, _UCLR,
    0,
    [_CLN, _To, _De],
    [[0, 1], () => Topics, 0], 1
];
export var UpdateContactListResponse$ = [3, n0, _UCLRp,
    0,
    [],
    []
];
export var UpdateContactRequest$ = [3, n0, _UCR,
    0,
    [_CLN, _EA, _TP, _UA, _ADt],
    [[0, 1], [0, 1], () => TopicPreferenceList, 2, 0], 2
];
export var UpdateContactResponse$ = [3, n0, _UCRp,
    0,
    [],
    []
];
export var UpdateCustomVerificationEmailTemplateRequest$ = [3, n0, _UCVETR,
    0,
    [_TN, _FEA, _TS, _TC, _SRURL, _FRURL],
    [[0, 1], 0, 0, 0, 0, 0], 6
];
export var UpdateCustomVerificationEmailTemplateResponse$ = [3, n0, _UCVETRp,
    0,
    [],
    []
];
export var UpdateEmailIdentityPolicyRequest$ = [3, n0, _UEIPR,
    0,
    [_EI, _PNo, _P],
    [[0, 1], [0, 1], 0], 3
];
export var UpdateEmailIdentityPolicyResponse$ = [3, n0, _UEIPRp,
    0,
    [],
    []
];
export var UpdateEmailTemplateRequest$ = [3, n0, _UETR,
    0,
    [_TN, _TC],
    [[0, 1], () => EmailTemplateContent$], 2
];
export var UpdateEmailTemplateResponse$ = [3, n0, _UETRp,
    0,
    [],
    []
];
export var UpdateReputationEntityCustomerManagedStatusRequest$ = [3, n0, _URECMSR,
    0,
    [_RET, _RER, _SS],
    [[0, 1], [0, 1], 0], 3
];
export var UpdateReputationEntityCustomerManagedStatusResponse$ = [3, n0, _URECMSRp,
    0,
    [],
    []
];
export var UpdateReputationEntityPolicyRequest$ = [3, n0, _UREPR,
    0,
    [_RET, _RER, _REP],
    [[0, 1], [0, 1], 0], 3
];
export var UpdateReputationEntityPolicyResponse$ = [3, n0, _UREPRp,
    0,
    [],
    []
];
export var VdmAttributes$ = [3, n0, _VA,
    0,
    [_VE, _DAa, _GA],
    [0, () => DashboardAttributes$, () => GuardianAttributes$], 1
];
export var VdmOptions$ = [3, n0, _VO,
    0,
    [_DOa, _GO],
    [() => DashboardOptions$, () => GuardianOptions$]
];
export var VerificationInfo$ = [3, n0, _VI,
    0,
    [_LCT, _LST, _ETr, _SOAR],
    [4, 4, 0, () => SOARecord$]
];
export var VolumeStatistics$ = [3, n0, _VS,
    0,
    [_IRC, _SRC, _PI, _PSr],
    [1, 1, 1, 1]
];
var AdditionalContactEmailAddresses = [1, n0, _ACEAd,
    8, [() => AdditionalContactEmailAddress,
        0]
];
var AttachmentList = [1, n0, _AL,
    0, () => Attachment$
];
var BatchGetMetricDataQueries = [1, n0, _BGMDQa,
    0, () => BatchGetMetricDataQuery$
];
var BlacklistEntries = [1, n0, _BEl,
    0, () => BlacklistEntry$
];
var BlacklistItemNames = 64 | 0;
var BulkEmailEntryList = [1, n0, _BEEL,
    0, () => BulkEmailEntry$
];
var BulkEmailEntryResultList = [1, n0, _BEERL,
    0, () => BulkEmailEntryResult$
];
var CloudWatchDimensionConfigurations = [1, n0, _CWDCl,
    0, () => CloudWatchDimensionConfiguration$
];
var ConfigurationSetNameList = 64 | 0;
var CustomVerificationEmailTemplatesList = [1, n0, _CVETL,
    0, () => CustomVerificationEmailTemplateMetadata$
];
var DailyVolumes = [1, n0, _DVa,
    0, () => DailyVolume$
];
var DedicatedIpList = [1, n0, _DIL,
    0, () => DedicatedIp$
];
var DeliverabilityTestReports = [1, n0, _DTReli,
    0, () => DeliverabilityTestReport$
];
var DnsTokenList = 64 | 0;
var DomainDeliverabilityCampaignList = [1, n0, _DDCL,
    0, () => DomainDeliverabilityCampaign$
];
var DomainDeliverabilityTrackingOptions = [1, n0, _DDTOo,
    0, () => DomainDeliverabilityTrackingOption$
];
var DomainIspPlacements = [1, n0, _DIP,
    0, () => DomainIspPlacement$
];
var EmailAddressFilterList = [1, n0, _EAFL,
    0, [() => InsightsEmailAddress,
        0]
];
var EmailAddressList = 64 | 0;
var EmailInsightsList = [1, n0, _EIL,
    0, [() => EmailInsights$,
        0]
];
var EmailSubjectFilterList = [1, n0, _ESFL,
    0, [() => EmailSubject,
        0]
];
var EmailTemplateMetadataList = [1, n0, _ETML,
    0, () => EmailTemplateMetadata$
];
var Esps = 64 | 0;
var EventDestinations = [1, n0, _EDven,
    0, () => EventDestination$
];
var EventTypes = 64 | 0;
var ExportDimensionValue = 64 | 0;
var ExportJobSummaryList = [1, n0, _EJSL,
    0, () => ExportJobSummary$
];
var ExportMetrics = [1, n0, _EMxp,
    0, () => ExportMetric$
];
var IdentityInfoList = [1, n0, _IIL,
    0, () => IdentityInfo$
];
var ImportJobSummaryList = [1, n0, _IJSL,
    0, () => ImportJobSummary$
];
var InsightsEvents = [1, n0, _IEn,
    0, () => InsightsEvent$
];
var IpList = 64 | 0;
var IspFilterList = 64 | 0;
var IspNameList = 64 | 0;
var IspPlacements = [1, n0, _IPs,
    0, () => IspPlacement$
];
var LastDeliveryEventList = 64 | 0;
var LastEngagementEventList = 64 | 0;
var ListOfContactLists = [1, n0, _LOCL,
    0, () => ContactList$
];
var ListOfContacts = [1, n0, _LOC,
    0, () => Contact$
];
var ListOfDedicatedIpPools = 64 | 0;
var MessageHeaderList = [1, n0, _MHL,
    0, () => MessageHeader$
];
var MessageTagList = [1, n0, _MTL,
    0, () => MessageTag$
];
var MetricDataErrorList = [1, n0, _MDEL,
    0, () => MetricDataError$
];
var MetricDataResultList = [1, n0, _MDRL,
    0, () => MetricDataResult$
];
var MetricValueList = 64 | 1;
var MultiRegionEndpoints = [1, n0, _MRE,
    0, () => MultiRegionEndpoint$
];
var RecommendationsList = [1, n0, _RL,
    0, () => Recommendation$
];
var Regions = 64 | 0;
var ReputationEntitiesList = [1, n0, _REL,
    0, () => ReputationEntity$
];
var ResourceTenantMetadataList = [1, n0, _RTML,
    0, () => ResourceTenantMetadata$
];
var Routes = [1, n0, _Ro,
    0, () => Route$
];
var RoutesDetails = [1, n0, _RDo,
    0, () => RouteDetails$
];
var SuppressedDestinationSummaries = [1, n0, _SDS,
    0, () => SuppressedDestinationSummary$
];
var SuppressionListReasons = 64 | 0;
var TagKeyList = 64 | 0;
var TagList = [1, n0, _TL,
    0, () => Tag$
];
var TenantInfoList = [1, n0, _TIL,
    0, () => TenantInfo$
];
var TenantResourceList = [1, n0, _TRL,
    0, () => TenantResource$
];
var TimestampList = 64 | 4;
var TopicPreferenceList = [1, n0, _TPL,
    0, () => TopicPreference$
];
var Topics = [1, n0, _To,
    0, () => Topic$
];
var BlacklistReport = [2, n0, _BR,
    0, 0, () => BlacklistEntries
];
var Dimensions = 128 | 0;
var ExportDimensions = [2, n0, _EDxp,
    0, 0, 64 | 0
];
var ListRecommendationsFilter = 128 | 0;
var ListTenantResourcesFilter = 128 | 0;
var PolicyMap = 128 | 0;
var ReputationEntityFilter = 128 | 0;
export var BatchGetMetricData$ = [9, n0, _BGMD,
    { [_h]: ["POST", "/v2/email/metrics/batch", 200] }, () => BatchGetMetricDataRequest$, () => BatchGetMetricDataResponse$
];
export var CancelExportJob$ = [9, n0, _CEJ,
    { [_h]: ["PUT", "/v2/email/export-jobs/{JobId}/cancel", 200] }, () => CancelExportJobRequest$, () => CancelExportJobResponse$
];
export var CreateConfigurationSet$ = [9, n0, _CCS,
    { [_h]: ["POST", "/v2/email/configuration-sets", 200] }, () => CreateConfigurationSetRequest$, () => CreateConfigurationSetResponse$
];
export var CreateConfigurationSetEventDestination$ = [9, n0, _CCSED,
    { [_h]: ["POST", "/v2/email/configuration-sets/{ConfigurationSetName}/event-destinations", 200] }, () => CreateConfigurationSetEventDestinationRequest$, () => CreateConfigurationSetEventDestinationResponse$
];
export var CreateContact$ = [9, n0, _CC,
    { [_h]: ["POST", "/v2/email/contact-lists/{ContactListName}/contacts", 200] }, () => CreateContactRequest$, () => CreateContactResponse$
];
export var CreateContactList$ = [9, n0, _CCL,
    { [_h]: ["POST", "/v2/email/contact-lists", 200] }, () => CreateContactListRequest$, () => CreateContactListResponse$
];
export var CreateCustomVerificationEmailTemplate$ = [9, n0, _CCVET,
    { [_h]: ["POST", "/v2/email/custom-verification-email-templates", 200] }, () => CreateCustomVerificationEmailTemplateRequest$, () => CreateCustomVerificationEmailTemplateResponse$
];
export var CreateDedicatedIpPool$ = [9, n0, _CDIP,
    { [_h]: ["POST", "/v2/email/dedicated-ip-pools", 200] }, () => CreateDedicatedIpPoolRequest$, () => CreateDedicatedIpPoolResponse$
];
export var CreateDeliverabilityTestReport$ = [9, n0, _CDTR,
    { [_h]: ["POST", "/v2/email/deliverability-dashboard/test", 200] }, () => CreateDeliverabilityTestReportRequest$, () => CreateDeliverabilityTestReportResponse$
];
export var CreateEmailIdentity$ = [9, n0, _CEI,
    { [_h]: ["POST", "/v2/email/identities", 200] }, () => CreateEmailIdentityRequest$, () => CreateEmailIdentityResponse$
];
export var CreateEmailIdentityPolicy$ = [9, n0, _CEIP,
    { [_h]: ["POST", "/v2/email/identities/{EmailIdentity}/policies/{PolicyName}", 200] }, () => CreateEmailIdentityPolicyRequest$, () => CreateEmailIdentityPolicyResponse$
];
export var CreateEmailTemplate$ = [9, n0, _CET,
    { [_h]: ["POST", "/v2/email/templates", 200] }, () => CreateEmailTemplateRequest$, () => CreateEmailTemplateResponse$
];
export var CreateExportJob$ = [9, n0, _CEJr,
    { [_h]: ["POST", "/v2/email/export-jobs", 200] }, () => CreateExportJobRequest$, () => CreateExportJobResponse$
];
export var CreateImportJob$ = [9, n0, _CIJ,
    { [_h]: ["POST", "/v2/email/import-jobs", 200] }, () => CreateImportJobRequest$, () => CreateImportJobResponse$
];
export var CreateMultiRegionEndpoint$ = [9, n0, _CMRE,
    { [_h]: ["POST", "/v2/email/multi-region-endpoints", 200] }, () => CreateMultiRegionEndpointRequest$, () => CreateMultiRegionEndpointResponse$
];
export var CreateTenant$ = [9, n0, _CTre,
    { [_h]: ["POST", "/v2/email/tenants", 200] }, () => CreateTenantRequest$, () => CreateTenantResponse$
];
export var CreateTenantResourceAssociation$ = [9, n0, _CTRA,
    { [_h]: ["POST", "/v2/email/tenants/resources", 200] }, () => CreateTenantResourceAssociationRequest$, () => CreateTenantResourceAssociationResponse$
];
export var DeleteConfigurationSet$ = [9, n0, _DCS,
    { [_h]: ["DELETE", "/v2/email/configuration-sets/{ConfigurationSetName}", 200] }, () => DeleteConfigurationSetRequest$, () => DeleteConfigurationSetResponse$
];
export var DeleteConfigurationSetEventDestination$ = [9, n0, _DCSED,
    { [_h]: ["DELETE", "/v2/email/configuration-sets/{ConfigurationSetName}/event-destinations/{EventDestinationName}", 200] }, () => DeleteConfigurationSetEventDestinationRequest$, () => DeleteConfigurationSetEventDestinationResponse$
];
export var DeleteContact$ = [9, n0, _DCel,
    { [_h]: ["DELETE", "/v2/email/contact-lists/{ContactListName}/contacts/{EmailAddress}", 200] }, () => DeleteContactRequest$, () => DeleteContactResponse$
];
export var DeleteContactList$ = [9, n0, _DCL,
    { [_h]: ["DELETE", "/v2/email/contact-lists/{ContactListName}", 200] }, () => DeleteContactListRequest$, () => DeleteContactListResponse$
];
export var DeleteCustomVerificationEmailTemplate$ = [9, n0, _DCVET,
    { [_h]: ["DELETE", "/v2/email/custom-verification-email-templates/{TemplateName}", 200] }, () => DeleteCustomVerificationEmailTemplateRequest$, () => DeleteCustomVerificationEmailTemplateResponse$
];
export var DeleteDedicatedIpPool$ = [9, n0, _DDIP,
    { [_h]: ["DELETE", "/v2/email/dedicated-ip-pools/{PoolName}", 200] }, () => DeleteDedicatedIpPoolRequest$, () => DeleteDedicatedIpPoolResponse$
];
export var DeleteEmailIdentity$ = [9, n0, _DEI,
    { [_h]: ["DELETE", "/v2/email/identities/{EmailIdentity}", 200] }, () => DeleteEmailIdentityRequest$, () => DeleteEmailIdentityResponse$
];
export var DeleteEmailIdentityPolicy$ = [9, n0, _DEIP,
    { [_h]: ["DELETE", "/v2/email/identities/{EmailIdentity}/policies/{PolicyName}", 200] }, () => DeleteEmailIdentityPolicyRequest$, () => DeleteEmailIdentityPolicyResponse$
];
export var DeleteEmailTemplate$ = [9, n0, _DETe,
    { [_h]: ["DELETE", "/v2/email/templates/{TemplateName}", 200] }, () => DeleteEmailTemplateRequest$, () => DeleteEmailTemplateResponse$
];
export var DeleteMultiRegionEndpoint$ = [9, n0, _DMRE,
    { [_h]: ["DELETE", "/v2/email/multi-region-endpoints/{EndpointName}", 200] }, () => DeleteMultiRegionEndpointRequest$, () => DeleteMultiRegionEndpointResponse$
];
export var DeleteSuppressedDestination$ = [9, n0, _DSD,
    { [_h]: ["DELETE", "/v2/email/suppression/addresses/{EmailAddress}", 200] }, () => DeleteSuppressedDestinationRequest$, () => DeleteSuppressedDestinationResponse$
];
export var DeleteTenant$ = [9, n0, _DTe,
    { [_h]: ["POST", "/v2/email/tenants/delete", 200] }, () => DeleteTenantRequest$, () => DeleteTenantResponse$
];
export var DeleteTenantResourceAssociation$ = [9, n0, _DTRA,
    { [_h]: ["POST", "/v2/email/tenants/resources/delete", 200] }, () => DeleteTenantResourceAssociationRequest$, () => DeleteTenantResourceAssociationResponse$
];
export var GetAccount$ = [9, n0, _GAe,
    { [_h]: ["GET", "/v2/email/account", 200] }, () => GetAccountRequest$, () => GetAccountResponse$
];
export var GetBlacklistReports$ = [9, n0, _GBR,
    { [_h]: ["GET", "/v2/email/deliverability-dashboard/blacklist-report", 200] }, () => GetBlacklistReportsRequest$, () => GetBlacklistReportsResponse$
];
export var GetConfigurationSet$ = [9, n0, _GCS,
    { [_h]: ["GET", "/v2/email/configuration-sets/{ConfigurationSetName}", 200] }, () => GetConfigurationSetRequest$, () => GetConfigurationSetResponse$
];
export var GetConfigurationSetEventDestinations$ = [9, n0, _GCSED,
    { [_h]: ["GET", "/v2/email/configuration-sets/{ConfigurationSetName}/event-destinations", 200] }, () => GetConfigurationSetEventDestinationsRequest$, () => GetConfigurationSetEventDestinationsResponse$
];
export var GetContact$ = [9, n0, _GC,
    { [_h]: ["GET", "/v2/email/contact-lists/{ContactListName}/contacts/{EmailAddress}", 200] }, () => GetContactRequest$, () => GetContactResponse$
];
export var GetContactList$ = [9, n0, _GCL,
    { [_h]: ["GET", "/v2/email/contact-lists/{ContactListName}", 200] }, () => GetContactListRequest$, () => GetContactListResponse$
];
export var GetCustomVerificationEmailTemplate$ = [9, n0, _GCVET,
    { [_h]: ["GET", "/v2/email/custom-verification-email-templates/{TemplateName}", 200] }, () => GetCustomVerificationEmailTemplateRequest$, () => GetCustomVerificationEmailTemplateResponse$
];
export var GetDedicatedIp$ = [9, n0, _GDI,
    { [_h]: ["GET", "/v2/email/dedicated-ips/{Ip}", 200] }, () => GetDedicatedIpRequest$, () => GetDedicatedIpResponse$
];
export var GetDedicatedIpPool$ = [9, n0, _GDIP,
    { [_h]: ["GET", "/v2/email/dedicated-ip-pools/{PoolName}", 200] }, () => GetDedicatedIpPoolRequest$, () => GetDedicatedIpPoolResponse$
];
export var GetDedicatedIps$ = [9, n0, _GDIe,
    { [_h]: ["GET", "/v2/email/dedicated-ips", 200] }, () => GetDedicatedIpsRequest$, () => GetDedicatedIpsResponse$
];
export var GetDeliverabilityDashboardOptions$ = [9, n0, _GDDO,
    { [_h]: ["GET", "/v2/email/deliverability-dashboard", 200] }, () => GetDeliverabilityDashboardOptionsRequest$, () => GetDeliverabilityDashboardOptionsResponse$
];
export var GetDeliverabilityTestReport$ = [9, n0, _GDTR,
    { [_h]: ["GET", "/v2/email/deliverability-dashboard/test-reports/{ReportId}", 200] }, () => GetDeliverabilityTestReportRequest$, () => GetDeliverabilityTestReportResponse$
];
export var GetDomainDeliverabilityCampaign$ = [9, n0, _GDDC,
    { [_h]: ["GET", "/v2/email/deliverability-dashboard/campaigns/{CampaignId}", 200] }, () => GetDomainDeliverabilityCampaignRequest$, () => GetDomainDeliverabilityCampaignResponse$
];
export var GetDomainStatisticsReport$ = [9, n0, _GDSR,
    { [_h]: ["GET", "/v2/email/deliverability-dashboard/statistics-report/{Domain}", 200] }, () => GetDomainStatisticsReportRequest$, () => GetDomainStatisticsReportResponse$
];
export var GetEmailAddressInsights$ = [9, n0, _GEAI,
    { [_h]: ["POST", "/v2/email/email-address-insights", 200] }, () => GetEmailAddressInsightsRequest$, () => GetEmailAddressInsightsResponse$
];
export var GetEmailIdentity$ = [9, n0, _GEI,
    { [_h]: ["GET", "/v2/email/identities/{EmailIdentity}", 200] }, () => GetEmailIdentityRequest$, () => GetEmailIdentityResponse$
];
export var GetEmailIdentityPolicies$ = [9, n0, _GEIP,
    { [_h]: ["GET", "/v2/email/identities/{EmailIdentity}/policies", 200] }, () => GetEmailIdentityPoliciesRequest$, () => GetEmailIdentityPoliciesResponse$
];
export var GetEmailTemplate$ = [9, n0, _GET,
    { [_h]: ["GET", "/v2/email/templates/{TemplateName}", 200] }, () => GetEmailTemplateRequest$, () => GetEmailTemplateResponse$
];
export var GetExportJob$ = [9, n0, _GEJ,
    { [_h]: ["GET", "/v2/email/export-jobs/{JobId}", 200] }, () => GetExportJobRequest$, () => GetExportJobResponse$
];
export var GetImportJob$ = [9, n0, _GIJ,
    { [_h]: ["GET", "/v2/email/import-jobs/{JobId}", 200] }, () => GetImportJobRequest$, () => GetImportJobResponse$
];
export var GetMessageInsights$ = [9, n0, _GMI,
    { [_h]: ["GET", "/v2/email/insights/{MessageId}", 200] }, () => GetMessageInsightsRequest$, () => GetMessageInsightsResponse$
];
export var GetMultiRegionEndpoint$ = [9, n0, _GMRE,
    { [_h]: ["GET", "/v2/email/multi-region-endpoints/{EndpointName}", 200] }, () => GetMultiRegionEndpointRequest$, () => GetMultiRegionEndpointResponse$
];
export var GetReputationEntity$ = [9, n0, _GRE,
    { [_h]: ["GET", "/v2/email/reputation/entities/{ReputationEntityType}/{ReputationEntityReference}", 200] }, () => GetReputationEntityRequest$, () => GetReputationEntityResponse$
];
export var GetSuppressedDestination$ = [9, n0, _GSD,
    { [_h]: ["GET", "/v2/email/suppression/addresses/{EmailAddress}", 200] }, () => GetSuppressedDestinationRequest$, () => GetSuppressedDestinationResponse$
];
export var GetTenant$ = [9, n0, _GT,
    { [_h]: ["POST", "/v2/email/tenants/get", 200] }, () => GetTenantRequest$, () => GetTenantResponse$
];
export var ListConfigurationSets$ = [9, n0, _LCS,
    { [_h]: ["GET", "/v2/email/configuration-sets", 200] }, () => ListConfigurationSetsRequest$, () => ListConfigurationSetsResponse$
];
export var ListContactLists$ = [9, n0, _LCL,
    { [_h]: ["GET", "/v2/email/contact-lists", 200] }, () => ListContactListsRequest$, () => ListContactListsResponse$
];
export var ListContacts$ = [9, n0, _LC,
    { [_h]: ["POST", "/v2/email/contact-lists/{ContactListName}/contacts/list", 200] }, () => ListContactsRequest$, () => ListContactsResponse$
];
export var ListCustomVerificationEmailTemplates$ = [9, n0, _LCVET,
    { [_h]: ["GET", "/v2/email/custom-verification-email-templates", 200] }, () => ListCustomVerificationEmailTemplatesRequest$, () => ListCustomVerificationEmailTemplatesResponse$
];
export var ListDedicatedIpPools$ = [9, n0, _LDIP,
    { [_h]: ["GET", "/v2/email/dedicated-ip-pools", 200] }, () => ListDedicatedIpPoolsRequest$, () => ListDedicatedIpPoolsResponse$
];
export var ListDeliverabilityTestReports$ = [9, n0, _LDTR,
    { [_h]: ["GET", "/v2/email/deliverability-dashboard/test-reports", 200] }, () => ListDeliverabilityTestReportsRequest$, () => ListDeliverabilityTestReportsResponse$
];
export var ListDomainDeliverabilityCampaigns$ = [9, n0, _LDDC,
    { [_h]: ["GET", "/v2/email/deliverability-dashboard/domains/{SubscribedDomain}/campaigns", 200] }, () => ListDomainDeliverabilityCampaignsRequest$, () => ListDomainDeliverabilityCampaignsResponse$
];
export var ListEmailIdentities$ = [9, n0, _LEI,
    { [_h]: ["GET", "/v2/email/identities", 200] }, () => ListEmailIdentitiesRequest$, () => ListEmailIdentitiesResponse$
];
export var ListEmailTemplates$ = [9, n0, _LET,
    { [_h]: ["GET", "/v2/email/templates", 200] }, () => ListEmailTemplatesRequest$, () => ListEmailTemplatesResponse$
];
export var ListExportJobs$ = [9, n0, _LEJ,
    { [_h]: ["POST", "/v2/email/list-export-jobs", 200] }, () => ListExportJobsRequest$, () => ListExportJobsResponse$
];
export var ListImportJobs$ = [9, n0, _LIJ,
    { [_h]: ["POST", "/v2/email/import-jobs/list", 200] }, () => ListImportJobsRequest$, () => ListImportJobsResponse$
];
export var ListMultiRegionEndpoints$ = [9, n0, _LMRE,
    { [_h]: ["GET", "/v2/email/multi-region-endpoints", 200] }, () => ListMultiRegionEndpointsRequest$, () => ListMultiRegionEndpointsResponse$
];
export var ListRecommendations$ = [9, n0, _LR,
    { [_h]: ["POST", "/v2/email/vdm/recommendations", 200] }, () => ListRecommendationsRequest$, () => ListRecommendationsResponse$
];
export var ListReputationEntities$ = [9, n0, _LRE,
    { [_h]: ["POST", "/v2/email/reputation/entities", 200] }, () => ListReputationEntitiesRequest$, () => ListReputationEntitiesResponse$
];
export var ListResourceTenants$ = [9, n0, _LRT,
    { [_h]: ["POST", "/v2/email/resources/tenants/list", 200] }, () => ListResourceTenantsRequest$, () => ListResourceTenantsResponse$
];
export var ListSuppressedDestinations$ = [9, n0, _LSD,
    { [_h]: ["GET", "/v2/email/suppression/addresses", 200] }, () => ListSuppressedDestinationsRequest$, () => ListSuppressedDestinationsResponse$
];
export var ListTagsForResource$ = [9, n0, _LTFR,
    { [_h]: ["GET", "/v2/email/tags", 200] }, () => ListTagsForResourceRequest$, () => ListTagsForResourceResponse$
];
export var ListTenantResources$ = [9, n0, _LTRis,
    { [_h]: ["POST", "/v2/email/tenants/resources/list", 200] }, () => ListTenantResourcesRequest$, () => ListTenantResourcesResponse$
];
export var ListTenants$ = [9, n0, _LTi,
    { [_h]: ["POST", "/v2/email/tenants/list", 200] }, () => ListTenantsRequest$, () => ListTenantsResponse$
];
export var PutAccountDedicatedIpWarmupAttributes$ = [9, n0, _PADIWA,
    { [_h]: ["PUT", "/v2/email/account/dedicated-ips/warmup", 200] }, () => PutAccountDedicatedIpWarmupAttributesRequest$, () => PutAccountDedicatedIpWarmupAttributesResponse$
];
export var PutAccountDetails$ = [9, n0, _PAD,
    { [_h]: ["POST", "/v2/email/account/details", 200] }, () => PutAccountDetailsRequest$, () => PutAccountDetailsResponse$
];
export var PutAccountPricingAttributes$ = [9, n0, _PAPA,
    { [_h]: ["PUT", "/v2/email/account/pricing-attributes", 200] }, () => PutAccountPricingAttributesRequest$, () => PutAccountPricingAttributesResponse$
];
export var PutAccountSendingAttributes$ = [9, n0, _PASA,
    { [_h]: ["PUT", "/v2/email/account/sending", 200] }, () => PutAccountSendingAttributesRequest$, () => PutAccountSendingAttributesResponse$
];
export var PutAccountSuppressionAttributes$ = [9, n0, _PASAu,
    { [_h]: ["PUT", "/v2/email/account/suppression", 200] }, () => PutAccountSuppressionAttributesRequest$, () => PutAccountSuppressionAttributesResponse$
];
export var PutAccountVdmAttributes$ = [9, n0, _PAVA,
    { [_h]: ["PUT", "/v2/email/account/vdm", 200] }, () => PutAccountVdmAttributesRequest$, () => PutAccountVdmAttributesResponse$
];
export var PutConfigurationSetArchivingOptions$ = [9, n0, _PCSAO,
    { [_h]: ["PUT", "/v2/email/configuration-sets/{ConfigurationSetName}/archiving-options", 200] }, () => PutConfigurationSetArchivingOptionsRequest$, () => PutConfigurationSetArchivingOptionsResponse$
];
export var PutConfigurationSetDeliveryOptions$ = [9, n0, _PCSDO,
    { [_h]: ["PUT", "/v2/email/configuration-sets/{ConfigurationSetName}/delivery-options", 200] }, () => PutConfigurationSetDeliveryOptionsRequest$, () => PutConfigurationSetDeliveryOptionsResponse$
];
export var PutConfigurationSetReputationOptions$ = [9, n0, _PCSRO,
    { [_h]: ["PUT", "/v2/email/configuration-sets/{ConfigurationSetName}/reputation-options", 200] }, () => PutConfigurationSetReputationOptionsRequest$, () => PutConfigurationSetReputationOptionsResponse$
];
export var PutConfigurationSetSendingOptions$ = [9, n0, _PCSSO,
    { [_h]: ["PUT", "/v2/email/configuration-sets/{ConfigurationSetName}/sending", 200] }, () => PutConfigurationSetSendingOptionsRequest$, () => PutConfigurationSetSendingOptionsResponse$
];
export var PutConfigurationSetSuppressionOptions$ = [9, n0, _PCSSOu,
    { [_h]: ["PUT", "/v2/email/configuration-sets/{ConfigurationSetName}/suppression-options", 200] }, () => PutConfigurationSetSuppressionOptionsRequest$, () => PutConfigurationSetSuppressionOptionsResponse$
];
export var PutConfigurationSetTrackingOptions$ = [9, n0, _PCSTO,
    { [_h]: ["PUT", "/v2/email/configuration-sets/{ConfigurationSetName}/tracking-options", 200] }, () => PutConfigurationSetTrackingOptionsRequest$, () => PutConfigurationSetTrackingOptionsResponse$
];
export var PutConfigurationSetVdmOptions$ = [9, n0, _PCSVO,
    { [_h]: ["PUT", "/v2/email/configuration-sets/{ConfigurationSetName}/vdm-options", 200] }, () => PutConfigurationSetVdmOptionsRequest$, () => PutConfigurationSetVdmOptionsResponse$
];
export var PutDedicatedIpInPool$ = [9, n0, _PDIIP,
    { [_h]: ["PUT", "/v2/email/dedicated-ips/{Ip}/pool", 200] }, () => PutDedicatedIpInPoolRequest$, () => PutDedicatedIpInPoolResponse$
];
export var PutDedicatedIpPoolScalingAttributes$ = [9, n0, _PDIPSA,
    { [_h]: ["PUT", "/v2/email/dedicated-ip-pools/{PoolName}/scaling", 200] }, () => PutDedicatedIpPoolScalingAttributesRequest$, () => PutDedicatedIpPoolScalingAttributesResponse$
];
export var PutDedicatedIpWarmupAttributes$ = [9, n0, _PDIWA,
    { [_h]: ["PUT", "/v2/email/dedicated-ips/{Ip}/warmup", 200] }, () => PutDedicatedIpWarmupAttributesRequest$, () => PutDedicatedIpWarmupAttributesResponse$
];
export var PutDeliverabilityDashboardOption$ = [9, n0, _PDDO,
    { [_h]: ["PUT", "/v2/email/deliverability-dashboard", 200] }, () => PutDeliverabilityDashboardOptionRequest$, () => PutDeliverabilityDashboardOptionResponse$
];
export var PutEmailIdentityConfigurationSetAttributes$ = [9, n0, _PEICSA,
    { [_h]: ["PUT", "/v2/email/identities/{EmailIdentity}/configuration-set", 200] }, () => PutEmailIdentityConfigurationSetAttributesRequest$, () => PutEmailIdentityConfigurationSetAttributesResponse$
];
export var PutEmailIdentityDkimAttributes$ = [9, n0, _PEIDA,
    { [_h]: ["PUT", "/v2/email/identities/{EmailIdentity}/dkim", 200] }, () => PutEmailIdentityDkimAttributesRequest$, () => PutEmailIdentityDkimAttributesResponse$
];
export var PutEmailIdentityDkimSigningAttributes$ = [9, n0, _PEIDSA,
    { [_h]: ["PUT", "/v2/email/identities/{EmailIdentity}/dkim/signing", 200] }, () => PutEmailIdentityDkimSigningAttributesRequest$, () => PutEmailIdentityDkimSigningAttributesResponse$
];
export var PutEmailIdentityFeedbackAttributes$ = [9, n0, _PEIFA,
    { [_h]: ["PUT", "/v2/email/identities/{EmailIdentity}/feedback", 200] }, () => PutEmailIdentityFeedbackAttributesRequest$, () => PutEmailIdentityFeedbackAttributesResponse$
];
export var PutEmailIdentityMailFromAttributes$ = [9, n0, _PEIMFA,
    { [_h]: ["PUT", "/v2/email/identities/{EmailIdentity}/mail-from", 200] }, () => PutEmailIdentityMailFromAttributesRequest$, () => PutEmailIdentityMailFromAttributesResponse$
];
export var PutSuppressedDestination$ = [9, n0, _PSD,
    { [_h]: ["PUT", "/v2/email/suppression/addresses", 200] }, () => PutSuppressedDestinationRequest$, () => PutSuppressedDestinationResponse$
];
export var PutTenantSuppressionAttributes$ = [9, n0, _PTSA,
    { [_h]: ["POST", "/v2/email/tenant/suppression", 200] }, () => PutTenantSuppressionAttributesRequest$, () => PutTenantSuppressionAttributesResponse$
];
export var SendBulkEmail$ = [9, n0, _SBE,
    { [_h]: ["POST", "/v2/email/outbound-bulk-emails", 200] }, () => SendBulkEmailRequest$, () => SendBulkEmailResponse$
];
export var SendCustomVerificationEmail$ = [9, n0, _SCVE,
    { [_h]: ["POST", "/v2/email/outbound-custom-verification-emails", 200] }, () => SendCustomVerificationEmailRequest$, () => SendCustomVerificationEmailResponse$
];
export var SendEmail$ = [9, n0, _SEen,
    { [_h]: ["POST", "/v2/email/outbound-emails", 200] }, () => SendEmailRequest$, () => SendEmailResponse$
];
export var TagResource$ = [9, n0, _TRa,
    { [_h]: ["POST", "/v2/email/tags", 200] }, () => TagResourceRequest$, () => TagResourceResponse$
];
export var TestRenderEmailTemplate$ = [9, n0, _TRET,
    { [_h]: ["POST", "/v2/email/templates/{TemplateName}/render", 200] }, () => TestRenderEmailTemplateRequest$, () => TestRenderEmailTemplateResponse$
];
export var UntagResource$ = [9, n0, _UR,
    { [_h]: ["DELETE", "/v2/email/tags", 200] }, () => UntagResourceRequest$, () => UntagResourceResponse$
];
export var UpdateConfigurationSetEventDestination$ = [9, n0, _UCSED,
    { [_h]: ["PUT", "/v2/email/configuration-sets/{ConfigurationSetName}/event-destinations/{EventDestinationName}", 200] }, () => UpdateConfigurationSetEventDestinationRequest$, () => UpdateConfigurationSetEventDestinationResponse$
];
export var UpdateContact$ = [9, n0, _UC,
    { [_h]: ["PUT", "/v2/email/contact-lists/{ContactListName}/contacts/{EmailAddress}", 200] }, () => UpdateContactRequest$, () => UpdateContactResponse$
];
export var UpdateContactList$ = [9, n0, _UCL,
    { [_h]: ["PUT", "/v2/email/contact-lists/{ContactListName}", 200] }, () => UpdateContactListRequest$, () => UpdateContactListResponse$
];
export var UpdateCustomVerificationEmailTemplate$ = [9, n0, _UCVET,
    { [_h]: ["PUT", "/v2/email/custom-verification-email-templates/{TemplateName}", 200] }, () => UpdateCustomVerificationEmailTemplateRequest$, () => UpdateCustomVerificationEmailTemplateResponse$
];
export var UpdateEmailIdentityPolicy$ = [9, n0, _UEIP,
    { [_h]: ["PUT", "/v2/email/identities/{EmailIdentity}/policies/{PolicyName}", 200] }, () => UpdateEmailIdentityPolicyRequest$, () => UpdateEmailIdentityPolicyResponse$
];
export var UpdateEmailTemplate$ = [9, n0, _UET,
    { [_h]: ["PUT", "/v2/email/templates/{TemplateName}", 200] }, () => UpdateEmailTemplateRequest$, () => UpdateEmailTemplateResponse$
];
export var UpdateReputationEntityCustomerManagedStatus$ = [9, n0, _URECMS,
    { [_h]: ["PUT", "/v2/email/reputation/entities/{ReputationEntityType}/{ReputationEntityReference}/customer-managed-status", 200] }, () => UpdateReputationEntityCustomerManagedStatusRequest$, () => UpdateReputationEntityCustomerManagedStatusResponse$
];
export var UpdateReputationEntityPolicy$ = [9, n0, _UREP,
    { [_h]: ["PUT", "/v2/email/reputation/entities/{ReputationEntityType}/{ReputationEntityReference}/policy", 200] }, () => UpdateReputationEntityPolicyRequest$, () => UpdateReputationEntityPolicyResponse$
];
